(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Download-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vusi-download-cards')) {
    class VusiDownloadCards extends HTMLElement {
      connectedCallback() {
        const source = `${navigator.userAgentData?.platform || ''} ${navigator.platform || ''} ${navigator.userAgent || ''}`.toLowerCase();
        let platform = 'windows';
        if (source.includes('mac') || source.includes('iphone') || source.includes('ipad')) platform = 'macos';
        if (source.includes('linux') || source.includes('android')) platform = 'linux';
        this.querySelectorAll('[data-platform-card]').forEach((card) => {
          card.dataset.platform = platform;
          const title = card.dataset[`${platform}Title`];
          const subtitle = card.dataset[`${platform}Subtitle`];
          const url = card.dataset[`${platform}Url`];
          const titleNode = card.querySelector('[data-platform-title]');
          const subtitleNode = card.querySelector('[data-platform-subtitle]');
          if (title && titleNode) titleNode.textContent = title;
          if (subtitleNode) subtitleNode.textContent = subtitle || '';
          if (url) card.href = url;
          if (title) card.setAttribute('aria-label', title);
        });
      }
    }
    customElements.define('vusi-download-cards', VusiDownloadCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-head"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vusi-editor-header')) {
    class VusiEditorHeader extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('[data-mobile-drawer]');
        this.openButton = this.querySelector('[data-mobile-open]');
        this.closeButton = this.querySelector('[data-mobile-close]');
        this.menuItems = [...this.querySelectorAll('[data-menu-item]')];
        this.actionMenu = this.querySelector('[data-action-menu]');
        this.syncMenuVideos = this.syncMenuVideos.bind(this);
        document.addEventListener('visibilitychange', this.syncMenuVideos);
        window.addEventListener('resize', this.syncMenuVideos, { passive: true });
        this.syncMenuVideos();
        this.lastFocused = null;
        this.closeTimer = null;
        this.headerBar = this.querySelector('[data-header-bar]');
        this.heroEnabled = this.dataset.pageType === 'index' && this.dataset.heroTransparent === 'true';
        this.mobileCta = this.querySelector('[data-mobile-header-cta]');
        this.updateScrolled = this.updateScrolled.bind(this);
        this.scheduleScrollUpdate = this.scheduleScrollUpdate.bind(this);
        this.refreshHero = this.refreshHero.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onCartUpdate = this.onCartUpdate.bind(this);
        window.addEventListener('scroll', this.scheduleScrollUpdate, { passive: true });
        window.addEventListener('resize', this.refreshHero, { passive: true });
        window.addEventListener('pageshow', this.refreshHero);
        window.addEventListener('load', this.refreshHero);
        document.addEventListener('DOMContentLoaded', this.refreshHero);
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => document.addEventListener(name, this.refreshHero));
        this.heroResizeObserver = new ResizeObserver(this.scheduleScrollUpdate);
        this.heroMutationObserver = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.shopify-section') || node.querySelector('.shopify-section'))))) this.refreshHero();
        });
        this.heroMutationObserver.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('vusi:cart-mutated', this.onCartUpdate);
        document.addEventListener('cart:updated', this.onCartUpdate);
        document.addEventListener('cart:refresh', this.onCartUpdate);
        document.addEventListener('product:added', this.onCartUpdate);
        VusiEditorHeader.observeCartRequests();
        this.refreshHero();
        this.menuItems.forEach((item, index) => {
          const trigger = item.querySelector(':scope > [data-menu-trigger]');
          const panel = item.querySelector(':scope > [data-menu-panel]');
          if (!trigger || !panel) return;
          item.addEventListener('mouseenter', () => this.openDesktopItem(item));
          item.addEventListener('mouseleave', () => this.scheduleDesktopClose(item));
          item.addEventListener('focusin', () => this.openDesktopItem(item));
          item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) this.scheduleDesktopClose(item, 0); });
          trigger.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown') { event.preventDefault(); this.openDesktopItem(item); panel.querySelector('[data-dropdown-link]')?.focus(); }
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); const direction = event.key === 'ArrowRight' ? 1 : -1; const nextIndex = (index + direction + this.menuItems.length) % this.menuItems.length; this.menuItems[nextIndex]?.querySelector('a, button')?.focus(); }
          });
          this.bindHoverTrack(panel);
          this.bindPreviews(panel);
        });
        if (this.actionMenu) {
          const trigger = this.actionMenu.querySelector('[data-action-trigger]');
          trigger?.addEventListener('click', event => { event.stopPropagation(); this.toggleActionMenu(); });
          trigger?.addEventListener('mouseenter', () => this.openActionMenu());
          this.actionMenu.addEventListener('mouseleave', () => this.closeActionMenu());
          this.bindHoverTrack(this.actionMenu);
        }
        this.openButton?.addEventListener('click', () => this.openMobile());
        this.closeButton?.addEventListener('click', () => this.closeMobile());
        this.querySelectorAll('[data-mobile-accordion]').forEach(button => button.addEventListener('click', () => this.toggleMobileAccordion(button)));
        this.drawer?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.closeMobile()));
      }
      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.syncMenuVideos);
        window.removeEventListener('resize', this.syncMenuVideos);
        this.querySelectorAll('video').forEach(video => video.pause());
        window.removeEventListener('scroll', this.scheduleScrollUpdate);
        window.removeEventListener('resize', this.refreshHero);
        window.removeEventListener('pageshow', this.refreshHero);
        window.removeEventListener('load', this.refreshHero);
        document.removeEventListener('DOMContentLoaded', this.refreshHero);
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => document.removeEventListener(name, this.refreshHero));
        this.heroResizeObserver?.disconnect();
        this.heroMutationObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.heroReadyFrame);
        this.mobileCtaAnimations?.forEach(animation => animation.cancel());
        this.scrollFrame = null;
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('vusi:cart-mutated', this.onCartUpdate);
        document.removeEventListener('cart:updated', this.onCartUpdate);
        document.removeEventListener('cart:refresh', this.onCartUpdate);
        document.removeEventListener('product:added', this.onCartUpdate);
        window.clearTimeout(this.closeTimer);
        if (this.classList.contains('is-mobile-open')) document.documentElement.style.overflow = '';
      }
      refreshHero() {
        if (!this.isConnected) return;
        const ownSection = this.closest('.shopify-section') || this;
        const main = document.querySelector('main, [role="main"], #MainContent');
        const searchRoot = main && !main.contains(this) ? main : document;
        this.hero = this.heroEnabled ? [...searchRoot.querySelectorAll('.shopify-section')].find(section =>
          section !== ownSection && !section.contains(this) &&
          (ownSection.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING) &&
          !section.matches('.shopify-section-group-header-group, .shopify-section-group-footer-group') &&
          section.getBoundingClientRect().height > 0 && getComputedStyle(section).visibility !== 'hidden'
        ) : null;
        this.classList.toggle('has-hero', Boolean(this.hero));
        this.heroResizeObserver.disconnect();
        if (this.hero) this.heroResizeObserver.observe(this.hero);
        if (this.headerBar) this.heroResizeObserver.observe(this.headerBar);
        this.heroResizeObserver.observe(document.body);
        this.scheduleScrollUpdate();
      }
      scheduleScrollUpdate() {
        if (this.scrollFrame != null) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          if (this.isConnected) this.updateScrolled();
        });
      }
      updateScrolled() {
        const hasHero = Boolean(this.hero?.isConnected);
        const overHero = hasHero && this.hero.getBoundingClientRect().bottom > this.headerBar.getBoundingClientRect().bottom;
        this.classList.toggle('is-over-hero', overHero);
        this.classList.toggle('is-scrolled', hasHero ? !overHero : window.scrollY > 2);
        this.updateMobileCta(overHero);
        if (!this.classList.contains('is-hero-ready') && !this.heroReadyFrame) {
          this.heroReadyFrame = requestAnimationFrame(() => {
            this.heroReadyFrame = null;
            if (this.isConnected) this.classList.add('is-hero-ready');
          });
        }
      }
      updateMobileCta(overHero) {
        if (!this.mobileCta) return;
        const useCommunity = this.dataset.pageType === 'product' || (this.dataset.pageType === 'index' && overHero);
        if (this.mobileCtaState === useCommunity) return;
        const firstUpdate = this.mobileCtaState === undefined;
        this.mobileCtaState = useCommunity;
        const label = this.mobileCta.querySelector('[data-mobile-cta-label]');
        const prefix = useCommunity ? 'community' : 'shop';
        const nextText = this.mobileCta.dataset[prefix + 'Label'];
        this.mobileCta.href = this.mobileCta.dataset[prefix + 'Url'];
        this.mobileCta.setAttribute('aria-label', nextText);
        label.setAttribute('aria-hidden', 'true');
        if (this.mobileCta.dataset[prefix + 'NewTab'] === 'true') {
          this.mobileCta.target = '_blank';
          this.mobileCta.rel = 'noopener noreferrer';
        } else {
          this.mobileCta.removeAttribute('target');
          this.mobileCta.removeAttribute('rel');
        }
        const createWord = text => {
          const word = document.createElement('span');
          word.className = 'xh-cta-word';
          const characters = typeof Intl.Segmenter === 'function'
            ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text), item => item.segment)
            : Array.from(text);
          characters.forEach(character => {
            const span = document.createElement('span');
            span.className = 'xh-cta-character';
            span.textContent = character;
            word.append(span);
          });
          return word;
        };
        const incoming = createWord(nextText);
        if (firstUpdate || this.dataset.pageType !== 'index' || !this.mobileCta.getClientRects().length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.mobileCtaAnimations?.forEach(animation => animation.cancel());
          this.mobileCtaAnimations = [];
          label.style.removeProperty('width');
          if (this.dataset.pageType === 'index') label.replaceChildren(incoming);
          else label.textContent = nextText;
          return;
        }
        const startWidth = label.getBoundingClientRect().width;
        const outgoing = Array.from(label.children);
        const currentFrames = Array.from(label.querySelectorAll('.xh-cta-character')).map(character => {
          const style = getComputedStyle(character);
          return { character, opacity: style.opacity, transform: style.transform, filter: style.filter };
        });
        this.mobileCtaAnimations?.forEach(animation => animation.cancel());
        label.style.width = startWidth + 'px';
        currentFrames.forEach(({ character, opacity, transform, filter }) => Object.assign(character.style, { opacity, transform, filter }));
        label.append(incoming);
        const endWidth = incoming.getBoundingClientRect().width;
        const duration = parseFloat(getComputedStyle(this).getPropertyValue('--xh-hero-duration')) || 450;
        const direction = useCommunity ? -1 : 1;
        const animations = [];
        this.mobileCtaAnimations = animations;
        const animate = (element, frames, options) => animations.push(element.animate(frames, { fill: 'both', ...options }));
        label.style.width = endWidth + 'px';
        animate(label, [{ width: startWidth + 'px' }, { width: endWidth + 'px' }], { duration, easing: 'cubic-bezier(.65, 0, .35, 1)' });
        outgoing.forEach(word => {
          Array.from(word.children).forEach((character, index, characters) => {
            const style = getComputedStyle(character);
            animate(character, [{ opacity: style.opacity, transform: style.transform, filter: style.filter }, { opacity: 0, transform: 'translateY(' + (-direction * 75) + '%)', filter: 'blur(2px)' }], { duration: duration * .38, delay: duration * .16 * index / Math.max(1, characters.length - 1), easing: 'cubic-bezier(.55, 0, 1, .45)' });
          });
        });
        Array.from(incoming.children).forEach((character, index, characters) => {
          animate(character, [{ opacity: 0, transform: 'translateY(' + (direction * 75) + '%)', filter: 'blur(2px)' }, { opacity: 1, transform: 'translateY(0)', filter: 'blur(0px)' }], { duration: duration * .64, delay: duration * (.12 + .24 * index / Math.max(1, characters.length - 1)), easing: 'cubic-bezier(.16, 1, .3, 1)' });
        });
        Promise.all(animations.map(animation => animation.finished)).then(() => {
          if (!this.isConnected || this.mobileCtaAnimations !== animations) return;
          outgoing.forEach(word => word.remove());
          animations.forEach(animation => animation.cancel());
          this.mobileCtaAnimations = [];
          label.style.removeProperty('width');
        }).catch(() => {});
      }
      static observeCartRequests() {
        if (window.__vusiHeaderCartObserverInstalled) return;
        window.__vusiHeaderCartObserverInstalled = true;
        const nativeFetch = window.fetch;
        window.fetch = async function(...args) {
          const response = await nativeFetch.apply(this, args);
          const input = args[0];
          const requestUrl = String(input instanceof Request ? input.url : input || '');
          if (response.ok && /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(requestUrl)) {
            window.setTimeout(() => document.dispatchEvent(new CustomEvent('vusi:cart-mutated')), 0);
          }
          return response;
        };
      }
      onCartUpdate(event) {
        const suppliedCart = event?.detail?.cart || event?.detail;
        if (suppliedCart && Number.isFinite(Number(suppliedCart.item_count))) {
          this.updatePrimaryCtas(Number(suppliedCart.item_count));
          return;
        }
        this.refreshCartCtas();
      }
      async refreshCartCtas() {
        if (!this.dataset.cartStateUrl) return;
        try {
          const response = await fetch(this.dataset.cartStateUrl, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return;
          const cartState = await response.json();
          this.updatePrimaryCtas(Number(cartState.item_count || 0));
        } catch (error) {

        }
      }
      updatePrimaryCtas(itemCount) {
        this.querySelectorAll('[data-primary-cta]').forEach(cta => {
          if (cta.dataset.cartEnabled !== 'true') return;
          const isCart = itemCount > 0;
          const includeCount = cta.dataset.showCartCount === 'true';
          if (cta.classList.contains('xh-mobile-header-primary')) {
            const label = cta.querySelector('[data-mobile-cta-label]');
            const cartIcon = cta.querySelector('[data-mobile-cta-cart]');
            const count = cta.querySelector('[data-mobile-cta-count]');
            cta.classList.toggle('is-cart', isCart);
            cta.setAttribute('aria-label', isCart ? `${cta.dataset.cartLabel}, ${itemCount} items` : cta.dataset.defaultLabel);
            if (label) label.hidden = isCart;
            if (cartIcon) cartIcon.hidden = !isCart;
            if (count) {
              count.textContent = String(itemCount);
              count.hidden = !isCart || !includeCount;
            }
          } else {
            cta.textContent = isCart ? `${cta.dataset.cartLabel}${includeCount ? ` (${itemCount})` : ''}` : cta.dataset.defaultLabel;
          }
          cta.href = isCart ? cta.dataset.cartUrl : cta.dataset.defaultUrl;
          cta.closest('[data-action-menu]')?.classList.toggle('is-cart', isCart);
          if (isCart || cta.dataset.defaultNewTab !== 'true') {
            cta.removeAttribute('target');
            cta.removeAttribute('rel');
          } else {
            cta.target = '_blank';
            cta.rel = 'noopener noreferrer';
          }
        });
      }
      syncMenuVideos() {
        this.querySelectorAll('video').forEach(video => {
          const preview = video.closest('[data-preview]');
          const item = video.closest('[data-menu-item]');
          const visible = !document.hidden && item?.classList.contains('is-open') && preview?.classList.contains('is-active') && video.getBoundingClientRect().width > 0;
          if (visible) {
            video.defaultMuted = true;
            video.muted = true;
            video.volume = 0;
            video.preload = 'auto';
            if (video.paused) video.play().catch(() => {});
          } else video.pause();
        });
      }
      openDesktopItem(item) {
        window.clearTimeout(this.closeTimer);
        this.closeActionMenu();
        this.menuItems.forEach(other => { const open = other === item; other.classList.toggle('is-open', open); other.querySelector(':scope > [data-menu-trigger]')?.setAttribute('aria-expanded', String(open)); });
        const firstLink = item.querySelector('[data-preview-target]');
        if (firstLink) this.showPreview(item, firstLink.dataset.previewTarget);
        this.syncMenuVideos();
      }
      scheduleDesktopClose(item, delay = 140) { window.clearTimeout(this.closeTimer); this.closeTimer = window.setTimeout(() => { item.classList.remove('is-open'); item.querySelector(':scope > [data-menu-trigger]')?.setAttribute('aria-expanded', 'false'); this.syncMenuVideos(); }, delay); }
      closeDesktopMenus() { this.menuItems.forEach(item => { item.classList.remove('is-open'); item.querySelector(':scope > [data-menu-trigger]')?.setAttribute('aria-expanded', 'false'); }); this.syncMenuVideos(); }
      bindHoverTrack(container) {
        const track = container.querySelector('[data-hover-track]');
        if (!track) return;
        const parent = track.parentElement;
        const links = [...parent.querySelectorAll('[data-dropdown-link]')];
        const move = link => { const parentRect = parent.getBoundingClientRect(); const rect = link.getBoundingClientRect(); track.style.top = `${rect.top - parentRect.top}px`; track.style.left = `${rect.left - parentRect.left}px`; track.style.width = `${rect.width}px`; track.style.height = `${rect.height}px`; track.style.opacity = '1'; };
        links.forEach(link => { link.addEventListener('mouseenter', () => move(link)); link.addEventListener('focus', () => move(link)); });
        parent.addEventListener('mouseleave', () => { track.style.opacity = '0'; });
      }
      bindPreviews(panel) { panel.querySelectorAll('[data-preview-target]').forEach(link => { const show = () => this.showPreview(panel, link.dataset.previewTarget); link.addEventListener('mouseenter', show); link.addEventListener('focus', show); }); }
      showPreview(container, key) { const stage = container.querySelector('[data-preview-stage]'); if (!stage) return; const previews = [...stage.querySelectorAll('[data-preview]')]; const target = previews.find(preview => preview.dataset.preview === key); stage.querySelector('[data-preview-empty]')?.classList.toggle('is-active', !target); previews.forEach(preview => preview.classList.toggle('is-active', preview === target)); this.syncMenuVideos(); }
      toggleActionMenu() { if (this.actionMenu?.classList.contains('is-open')) this.closeActionMenu(); else this.openActionMenu(); }
      openActionMenu() { if (!this.actionMenu) return; this.closeDesktopMenus(); this.actionMenu.classList.add('is-open'); this.actionMenu.querySelector('[data-action-trigger]')?.setAttribute('aria-expanded', 'true'); }
      closeActionMenu() { if (!this.actionMenu) return; this.actionMenu.classList.remove('is-open'); this.actionMenu.querySelector('[data-action-trigger]')?.setAttribute('aria-expanded', 'false'); }
      openMobile() { this.lastFocused = document.activeElement; this.classList.add('is-mobile-open'); this.openButton?.setAttribute('aria-expanded', 'true'); this.drawer?.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; this.closeButton?.focus(); }
      closeMobile() { if (!this.classList.contains('is-mobile-open')) return; this.classList.remove('is-mobile-open'); this.openButton?.setAttribute('aria-expanded', 'false'); this.drawer?.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; this.lastFocused?.focus(); }
      toggleMobileAccordion(button) {
        const item = button.closest('.xh-mobile-item');
        const willOpen = !item.classList.contains('is-open');
        this.querySelectorAll('.xh-mobile-item.is-open').forEach(openItem => { if (openItem !== item) { openItem.classList.remove('is-open'); openItem.querySelector('[data-mobile-accordion]')?.setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      }
      onDocumentClick(event) { if (!this.contains(event.target)) { this.closeDesktopMenus(); this.closeActionMenu(); } }
      onKeydown(event) {
        if (event.key === 'Tab' && this.classList.contains('is-mobile-open')) {
          const focusable = [...this.drawer.querySelectorAll('a[href], button:not([disabled])')].filter(element => element.offsetParent !== null);
          if (!focusable.length) return;
          const first = focusable[0]; const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          return;
        }
        if (event.key !== 'Escape') return;
        if (this.classList.contains('is-mobile-open')) this.closeMobile();
        else { this.closeDesktopMenus(); this.closeActionMenu(); }
      }
    }
    customElements.define('vusi-editor-header', VusiEditorHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-captions"] && !Shopify.designMode) return;
  try {
    
(() => {
 const controllers = new Map();
 function init(root) {
  root.querySelectorAll('.vusi-ic').forEach(section => {
   if (controllers.has(section)) return;
   const videos = [...section.querySelectorAll('.vusi-ic__video')];
   const motion = matchMedia('(prefers-reduced-motion:reduce)');
   const visible = new Set(), warmed = new Set(), pending = new Set();
   let disposed = false;
   const shouldPlay = video => !disposed && visible.has(video) && !document.hidden && !motion.matches;
   function play(video) {
    if (!shouldPlay(video) || !video.paused || pending.has(video)) return;
    pending.add(video);
    video.play().catch(() => {}).finally(() => {
     pending.delete(video);
     if (!shouldPlay(video)) video.pause();
    });
   }
   function update() {
    videos.forEach(video => {
     if (shouldPlay(video)) play(video);
     else video.pause();
    });
   }
   const preload = new IntersectionObserver(entries => {
    entries.forEach(entry => {
     if (!entry.isIntersecting || warmed.has(entry.target)) return;
     const video = entry.target;
     warmed.add(video);
     video.preload = 'auto';
     if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) video.load();
    });
   }, {rootMargin:'600px 0px'});
   const playback = new IntersectionObserver(entries => {
    entries.forEach(entry => {
     if (entry.isIntersecting) visible.add(entry.target);
     else visible.delete(entry.target);
    });
    update();
   }, {rootMargin:'0px 0px'});
   const ready = event => play(event.currentTarget);
   videos.forEach(video => {
    video.muted = true;
    video.playsInline = true;
    video.addEventListener('loadeddata', ready);
    video.addEventListener('canplay', ready);
    preload.observe(video);
    playback.observe(video);
   });
   motion.addEventListener('change', update);
   document.addEventListener('visibilitychange', update);
   controllers.set(section, () => {
    disposed = true;
    preload.disconnect();
    playback.disconnect();
    motion.removeEventListener('change', update);
    document.removeEventListener('visibilitychange', update);
    videos.forEach(video => {
     video.removeEventListener('loadeddata', ready);
     video.removeEventListener('canplay', ready);
     video.pause();
    });
   });
  });
 }
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
 document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.vusi-ic').forEach(section => {
   controllers.get(section)?.();
   controllers.delete(section);
  });
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-stack"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vusi-image-card-stack')) {
    class VusiImageCardStack extends HTMLElement {
      number(name, fallback) {
        const value = Number.parseFloat(this.dataset[name]);
        return Number.isFinite(value) ? value : fallback;
      }

      cssNumber(name, fallback) {
        const value = Number.parseFloat(getComputedStyle(this).getPropertyValue(name));
        return Number.isFinite(value) ? value : fallback;
      }

      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.stage = this.querySelector('[data-stage]');
        this.originals = Array.from(this.stage.querySelectorAll('[data-card]'));
        if (this.originals.length > 1 && this.originals.length < 5) {
          const copies = Math.ceil(5 / this.originals.length);
          for (let copy = 1; copy < copies; copy += 1) {
            this.originals.forEach((card) => {
              const clone = card.cloneNode(true);
              clone.dataset.clone = 'true';
              clone.removeAttribute('data-shopify-editor-block');
              clone.classList.remove('is-active');
              this.stage.append(clone);
            });
          }
        }
        this.cards = Array.from(this.stage.querySelectorAll('[data-card]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.captionOutput = this.querySelector('[data-caption-output]');
        this.captionWidth = this.querySelector('[data-caption-width]');
        this.captionText = this.querySelector('[data-caption-text]');
        this.progress = 0;
        this.activeIndex = 0;
        this.hoverFrame = null;
        this.transitionFrame = null;
        this.touch = null;
        this.busy = false;
        this.hovered = false;
        this.focused = false;
        this.paused = false;
        this.editorPaused = false;
        this.editorSelectedCard = null;
        this.inView = true;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedMotion = this.motionQuery.matches;
        this.activeVideo = null;
        this.setupVideos(signal);
        this.hoverStates = this.cards.map((card) => ({
          card,
          wrapper: card.querySelector('[data-hover-wrapper]'),
          rotator: card.querySelector('[data-rotator]'),
          value: [0, 0, 1, 0, 50, 50, 50, 50],
          velocity: [0, 0, 0, 0, 0, 0, 0, 0],
          target: [0, 0, 1, 0, 50, 50, 50, 50],
          returning: false
        }));
        this.hoverStates.forEach((state) => this.drawHover(state));
        this.options = {
          spread: this.cssNumber('--stack-side-offset', 14),
          rotation: this.cssNumber('--stack-rotation', 2.4),
          depth: this.cssNumber('--stack-depth', 170),
          outerOpacity: this.cssNumber('--stack-side-opacity', .6),
          visible: this.number('visibleCards', 2),
          first: this.number('firstOffset', 12),
          flyout: this.number('flyout', 77),
          backMidpoint: this.number('backMidpoint', 5),
          flip: this.number('flip', 45),
          backFlip: this.number('backFlip', 20),
          midScale: this.number('midScale', .95),
          perspective: this.number('perspective', 1000)
        };
        this.previousButton.addEventListener('click', () => this.go(-1, true), { signal });
        this.nextButton.addEventListener('click', () => this.go(1, true), { signal });
        this.pauseButton?.addEventListener('click', () => {
          this.paused = !this.paused;
          if (!this.paused && this.activeVideo) {
            this.activeVideo.userStarted = true;
            this.activeVideo.blocked = false;
          }
          this.updatePause();
          this.schedule();
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('input, textarea, select, [contenteditable]')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(event.key === 'ArrowLeft' ? -1 : 1, true);
          }
        }, { signal });
        this.stage.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          if (this.pauseOnHover()) this.schedule();
        }, { signal });
        this.stage.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.resetHover();
          this.schedule();
        }, { signal });
        this.addEventListener('focusin', (event) => {
          this.focused = event.target.matches(':focus-visible');
          this.schedule();
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (this.contains(event.relatedTarget)) return;
          this.focused = false;
          this.schedule();
        }, { signal });
        this.hoverStates.forEach((state) => {
          state.wrapper.addEventListener('pointermove', (event) => this.tilt(event, state), { signal });
          state.wrapper.addEventListener('pointerleave', () => this.resetHover(state), { signal });
        });
        this.stage.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
          this.touch = { x: event.clientX, y: event.clientY, id: event.pointerId, swiped: false };
          this.schedule();
        }, { signal });
        this.stage.addEventListener('pointermove', (event) => {
          if (!this.touch || event.pointerId !== this.touch.id) return;
          const dx = event.clientX - this.touch.x;
          const dy = event.clientY - this.touch.y;
          if (Math.abs(dx) > 34 && Math.abs(dx) > Math.abs(dy) * 1.2 && !this.touch.swiped) {
            this.touch.swiped = true;
            this.suppressClickUntil = performance.now() + 500;
            this.go(dx < 0 ? 1 : -1, true);
          }
        }, { signal });
        const endTouch = () => { this.touch = null; this.schedule(); };
        this.stage.addEventListener('pointerup', endTouch, { signal });
        this.stage.addEventListener('pointercancel', endTouch, { signal });
        this.stage.addEventListener('click', (event) => {
          if (performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { signal, capture: true });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-card]');
          if (!card) return;
          this.editorSelectedCard = card;
          this.editorPaused = true;
          this.stopAutoplay();
          this.select(Number(card.dataset.index), false);
        }, { signal });
        this.addEventListener('shopify:block:deselect', (event) => {
          if (event.target.closest('[data-card]') !== this.editorSelectedCard) return;
          this.editorSelectedCard = null;
          this.editorPaused = false;
          this.schedule();
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (!event.target.contains(this)) return;
          this.editorSelectedCard = null;
          this.editorPaused = false;
          this.schedule();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motionQuery.addEventListener('change', () => {
          this.reducedMotion = this.motionQuery.matches;
          if (this.reducedMotion) {
            this.select(this.busy ? this.targetIndex : this.activeIndex, false);
            this.resetHover();
          }
          this.schedule();
        }, { signal });
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          if (this.inView) this.classList.add('is-visible');
          this.schedule();
        }, { threshold: 0 });
        this.observer.observe(this);
        this.cards.forEach((card) => { card.frontPass = false; });
        this.render(0, 1, 0);
        this.finishSelection(0, false);
        this.previousButton.disabled = this.nextButton.disabled = this.originals.length < 2;
        if (this.pauseButton) this.pauseButton.hidden = this.originals.length < 2 && !this.videoStates.some(Boolean);
        this.dataset.ready = 'true';
        this.schedule();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.videoStates?.forEach((state) => { if (state) this.resetVideo(state, true); });
        this.activeVideo = null;
        cancelAnimationFrame(this.transitionFrame);
        cancelAnimationFrame(this.hoverFrame);
        this.transitionFrame = null;
        this.hoverFrame = null;
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.querySelectorAll('[data-clone]').forEach((node) => node.remove());
        this.querySelectorAll('*').forEach((node) => node.getAnimations().forEach((animation) => animation.cancel()));
        delete this.dataset.ready;
      }

      interpolate(value, points, values, clamp = true) {
        if (clamp) value = Math.max(points[0], Math.min(points[points.length - 1], value));
        let index = 0;
        while (index < points.length - 2 && value > points[index + 1]) index += 1;
        const progress = (value - points[index]) / (points[index + 1] - points[index]);
        return values[index] + (values[index + 1] - values[index]) * progress;
      }

      easing(time, first = .4, second = .2) {
        if (time <= 0) return 0;
        if (time >= 1) return 1;
        const bezier = (t, a, b) => 3 * (1 - t) * (1 - t) * t * a + 3 * (1 - t) * t * t * b + t * t * t;
        let low = 0;
        let high = 1;
        for (let step = 0; step < 16; step += 1) {
          const middle = (low + high) / 2;
          if (bezier(middle, first, second) < time) low = middle;
          else high = middle;
        }
        return bezier((low + high) / 2, 0, 1);
      }

      render(progress, direction, outgoing) {
        const count = this.cards.length;
        const o = this.options;
        this.progress = progress;
        this.cards.forEach((card, index) => {
          let delta = ((progress - index) % count + count) % count;
          if (delta > count / 2) delta -= count;
          const distance = Math.abs(delta);
          const front = index === outgoing && distance < 1;
          const peak = front ? o.flyout : o.backMidpoint;
          let x = this.interpolate(delta, [-1, -.5, 0, .5, 1], [o.first, peak, 0, -peak, -o.first], false);
          if (distance >= 1) x = -Math.sign(delta) * (o.first + (distance - 1) * o.spread);
          const z = -distance * o.depth;
          const rotateZ = -delta * o.rotation;
          const rotateY = this.interpolate(distance % 1, [0, .5, 1], [0, -(front ? o.flip : o.backFlip), 0]) * direction;
          const scale = front ? this.interpolate(distance, [0, .5, 1], [1, o.midScale, 1]) : 1;
          const zIndex = Math.round(this.interpolate(distance, [0, .5, 1, 2, 2.5], [10, 1, 0, -1, -2]));
          const outer = Math.max(1, o.visible);
          const opacity = outer === 1
            ? this.interpolate(distance, [0, 1, 1.15], [1, 1, 0])
            : this.interpolate(distance, [0, 1, outer, outer + .15], [1, 1, o.outerOpacity, 0]);
          card.style.transform = 'perspective(' + o.perspective + 'px) translateX(' + x + '%) translateZ(' + z + 'px) scale(' + scale + ') rotateY(' + rotateY + 'deg) rotateZ(' + rotateZ + 'deg)';
          card.style.opacity = opacity;
          card.style.zIndex = zIndex;
        });
      }

      go(direction, manual = false) {
        if (this.busy || this.originals.length < 2) return;
        const target = (this.activeIndex + direction + this.cards.length) % this.cards.length;
        this.select(target, !this.reducedMotion, direction, manual);
      }

      select(index, animate = true, direction = 1, manual = false) {
        this.stopAutoplay();
        cancelAnimationFrame(this.transitionFrame);
        this.resetHover();
        const count = this.cards.length;
        const target = ((index % count) + count) % count;
        this.targetIndex = target;
        const outgoing = this.activeIndex;
        if (!animate || this.reducedMotion || outgoing === target) {
          this.busy = false;
          this.render(target, direction, target);
          this.finishSelection(target, manual);
          this.schedule();
          return;
        }
        this.busy = true;
        this.dataset.moving = 'true';
        this.cards.forEach((card) => { card.inert = true; card.classList.remove('is-active'); });
        const duration = Math.max(1, this.number('speed', 800));
        if (this.activeVideo && !this.activeVideo.resetting) {
          this.fadeVideo(this.activeVideo, 0, Math.min(duration, this.number('videoFadeMs', 600)));
        }
        this.syncVideo();
        const start = this.activeIndex;
        let difference = target - start;
        if (direction > 0 && difference < 0) difference += count;
        if (direction < 0 && difference > 0) difference -= count;
        const began = performance.now();
        const tick = (now) => {
          if (!this.isConnected) return;
          const elapsed = Math.min(1, (now - began) / duration);
          this.render(start + difference * this.easing(elapsed), direction, outgoing);
          if (elapsed < 1) this.transitionFrame = requestAnimationFrame(tick);
          else {
            this.busy = false;
            delete this.dataset.moving;
            this.render(target, direction, target);
            this.finishSelection(target, manual);
            this.schedule(manual ? Math.max(0, this.number('delay', 3000) - duration) : undefined);
          }
        };
        this.transitionFrame = requestAnimationFrame(tick);
      }

      finishSelection(index, manual) {
        this.activeIndex = index;
        delete this.dataset.moving;
        this.dataset.activeIndex = this.cards[index].dataset.index;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === index;
          card.inert = !active;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', String(!active));
          card.querySelectorAll('a').forEach((link) => { link.tabIndex = active ? 0 : -1; });
        });
        if (this.captionOutput) this.captionOutput.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.updateCaption(this.cards[index].dataset.caption || '');
        this.activateVideo(index);
        this.updatePause();
      }

      updateCaption(text) {
        if (!this.captionText) return;
        if (this.captionValue === text) return;
        const segment = (value) => typeof Intl.Segmenter === 'function'
          ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value), (part) => part.segment)
          : Array.from(value);
        const oldNodes = Array.from(this.captionText.children).filter((node) => !node.dataset.exiting);
        const before = oldNodes.map((node) => ({ node, text: node.textContent, x: node.offsetLeft }));
        const after = segment(text);
        const was = this.captionValue;
        const oldWidth = this.captionText.getBoundingClientRect().width;
        this.captionValue = text;
        this.captionText.setAttribute('aria-label', text);
        this.captionText.querySelectorAll('[data-exiting]').forEach((node) => node.remove());
        this.captionText.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
        if (was === undefined || this.reducedMotion || this.dataset.animateCaption === 'false') {
          this.captionText.replaceChildren(...after.map((character) => {
            const node = document.createElement('span');
            node.textContent = character;
            node.setAttribute('aria-hidden', 'true');
            return node;
          }));
          this.captionWidth.style.width = '';
          return;
        }
        const table = Array.from({ length: before.length + 1 }, () => Array(after.length + 1).fill(0));
        for (let i = 1; i <= before.length; i += 1) {
          for (let j = 1; j <= after.length; j += 1) {
            table[i][j] = before[i - 1].text === after[j - 1] ? table[i - 1][j - 1] + 1 : Math.max(table[i - 1][j], table[i][j - 1]);
          }
        }
        const matches = new Map();
        let i = before.length;
        let j = after.length;
        while (i > 0 && j > 0) {
          if (before[i - 1].text === after[j - 1]) { matches.set(j - 1, before[i - 1]); i -= 1; j -= 1; }
          else if (table[i - 1][j] > table[i][j - 1] || (table[i - 1][j] === table[i][j - 1] && i >= j)) i -= 1;
          else j -= 1;
        }
        const retained = new Set(Array.from(matches.values(), (entry) => entry.node));
        const ratio = (before.length + after.length - matches.size * 2) / Math.max(1, before.length, after.length);
        const options = { duration: this.number('captionSpeed', 380), easing: 'cubic-bezier(.19,1,.22,1)' };
        const removed = before.filter((entry) => !retained.has(entry.node));
        const nodes = after.map((character, index) => {
          const node = matches.get(index)?.node || document.createElement('span');
          node.textContent = character;
          node.setAttribute('aria-hidden', 'true');
          return node;
        });
        this.captionText.replaceChildren(...nodes);
        nodes.forEach((node, index) => {
          const match = matches.get(index);
          const drift = (after.length <= 1 ? 0 : index / (after.length - 1) - .5) * 15 * ratio;
          node.animate(match
            ? [{ transform: 'translateX(' + (match.x - node.offsetLeft) + 'px)' }, { transform: 'translateX(0)' }]
            : [{ opacity: 0, filter: 'blur(4px)', transform: 'translateX(' + drift + 'px) scale(.85)' }, { opacity: 1, filter: 'blur(0)', transform: 'translateX(0) scale(1)' }], options);
        });
        const newWidth = this.captionText.getBoundingClientRect().width;
        this.captionWidth.style.width = newWidth + 'px';
        this.captionWidth.getAnimations().forEach((animation) => animation.cancel());
        this.captionWidth.animate([{ width: oldWidth + 'px' }, { width: newWidth + 'px' }], options);
        removed.forEach(({ node, x }) => {
          node.dataset.exiting = 'true';
          node.style.position = 'absolute';
          node.style.left = x + 'px';
          node.style.top = '0';
          this.captionText.append(node);
          const animation = node.animate([{ opacity: 1, filter: 'blur(0)', transform: 'scale(1)' }, { opacity: 0, filter: 'blur(4px)', transform: 'scale(.85)' }], { ...options, fill: 'forwards' });
          animation.finished.then(() => node.remove()).catch(() => node.remove());
        });
      }

      tilt(event, state) {
        if (this.reducedMotion || this.busy || event.pointerType === 'touch' || !state.card.classList.contains('is-active')) return;
        const rect = state.rotator.getBoundingClientRect();
        const x = Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
        const y = Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100));
        const strength = this.dataset.tilt === 'true' ? this.number('tiltStrength', 14) / 14 : 0;
        state.target = [(y - 50) / 3.5 * strength, -(x - 50) / 3.5 * strength, this.number('hoverScale', 1.05), 1, x, y, 37 + x * .26, 33 + y * .34];
        state.returning = false;
        this.startHover();
      }

      resetHover(single) {
        (single ? [single] : this.hoverStates || []).forEach((state) => {
          state.target = [0, 0, 1, 0, 50, 50, 50, 50];
          state.returning = true;
          if (this.reducedMotion) {
            state.value = [...state.target];
            state.velocity.fill(0);
            this.drawHover(state);
          }
        });
        if (!this.reducedMotion) this.startHover();
      }

      drawHover(state) {
        const [rx, ry, scale, opacity, x, y, bx, by] = state.value;
        state.wrapper.style.transform = 'scale(' + scale + ')';
        state.rotator.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
        state.wrapper.style.setProperty('--hover-opacity', opacity);
        state.wrapper.style.setProperty('--pointer-x', x + '%');
        state.wrapper.style.setProperty('--pointer-y', y + '%');
        state.wrapper.style.setProperty('--background-x', bx + '%');
        state.wrapper.style.setProperty('--background-y', by + '%');
      }

      startHover() {
        if (this.hoverFrame || !this.isConnected) return;
        let previous = performance.now();
        const tick = (now) => {
          const elapsed = Math.min(.064, Math.max(.001, (now - previous) / 1000));
          previous = now;
          let unsettled = false;
          this.hoverStates.forEach((state) => {
            const stiffness = this.number(state.returning ? 'returnStiffness' : 'stiffness', state.returning ? 120 : 180);
            const damping = this.number(state.returning ? 'returnDamping' : 'damping', state.returning ? 22 : 28);
            const steps = Math.ceil(elapsed * 240);
            const dt = elapsed / steps;
            state.value.forEach((value, index) => {
              let velocity = state.velocity[index];
              const target = state.target[index];
              for (let step = 0; step < steps; step += 1) {
                velocity += (-stiffness * (value - target) - damping * velocity) * dt;
                value += velocity * dt;
              }
              if (Math.abs(value - target) < .0002 && Math.abs(velocity) < .002) { value = target; velocity = 0; }
              else unsettled = true;
              state.value[index] = value;
              state.velocity[index] = velocity;
            });
            this.drawHover(state);
          });
          this.hoverFrame = unsettled && this.isConnected ? requestAnimationFrame(tick) : null;
        };
        this.hoverFrame = requestAnimationFrame(tick);
      }

      setupVideos(signal) {
        this.videoStates = this.cards.map((card) => {
          const video = card.querySelector('.vusi-image-stack__video');
          if (!video) return null;
          const seconds = Number.parseFloat(card.dataset.videoSeconds);
          const state = {
            card, video, button: card.querySelector('[data-video-play]'),
            seconds: Number.isFinite(seconds) ? Math.max(1, seconds) : 10,
            timed: card.dataset.videoMode === 'timed',
            readyToAdvance: false, restartPending: false, elapsed: 0, lastTime: 0,
            mediaLevel: 1, mediaFrame: null, rewindFrame: null, resetting: false, resetCleanup: null,
            failed: false, blocked: false, starting: false, userStarted: false, attempt: 0
          };
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.loop = false;
          video.addEventListener('ended', () => this.videoEnded(state), { signal });
          video.addEventListener('timeupdate', () => {
            if (state !== this.activeVideo || this.busy || state.failed) return;
            this.recordVideoTime(state);
            if (state.timed && state.elapsed >= state.seconds) this.finishVideo(state);
          }, { signal });
          video.addEventListener('playing', () => {
            if (state !== this.activeVideo || this.shouldPauseVideo(state)) this.pauseVideo(state);
          }, { signal });
          video.addEventListener('error', () => {
            state.failed = true;
            this.pauseVideo(state);
            this.cancelVideoReset(state);
            this.fadeVideo(state, 1, 0);
            this.updateVideoButton(state);
            if (state === this.activeVideo) this.schedule();
          }, { signal });
          state.button?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (state !== this.activeVideo) return;
            state.userStarted = true;
            state.blocked = false;
            this.paused = false;
            this.updatePause();
            this.schedule();
          }, { signal });
          return state;
        });
      }

      activateVideo(index) {
        const next = this.videoStates[index];
        if (next !== this.activeVideo) {
          const outgoing = this.activeVideo;
          this.activeVideo = next;
          if (outgoing) this.resetVideo(outgoing);
          if (next) {
            next.readyToAdvance = false;
            next.restartPending = false;
            next.elapsed = 0;
            next.lastTime = 0;
            next.blocked = false;
            next.failed = false;
            next.userStarted = false;
            if (next.video.error) next.video.load();
          }
        }
        if (next && !next.resetting) this.fadeVideo(next, 1, this.number('videoFadeMs', 600));
        this.videoStates.forEach((state) => {
          if (!state) return;
          if (state !== this.activeVideo) this.pauseVideo(state);
          this.updateVideoButton(state);
        });
      }

      shouldPauseVideo(state) {
        return !this.isConnected || this.paused || this.touch || !this.inView || document.hidden ||
          (!state.userStarted && (this.reducedMotion || this.focused || (this.hovered && this.pauseOnHover())));
      }

      pauseVideo(state) {
        if (!state.starting && state.video.paused) return;
        state.attempt += 1;
        state.starting = false;
        state.video.pause();
      }

      drawVideo(state, level) {
        state.mediaLevel = Math.max(0, Math.min(1, level));
        state.video.style.opacity = String(state.mediaLevel);
        const blur = this.reducedMotion ? 0 : (1 - state.mediaLevel) * this.number('videoBlur', 12);
        state.video.style.filter = 'blur(' + blur + 'px)';
      }

      fadeVideo(state, target, duration, complete) {
        cancelAnimationFrame(state.mediaFrame);
        state.mediaFrame = null;
        const start = state.mediaLevel;
        if (this.reducedMotion || !this.isConnected || duration <= 0 || Math.abs(start - target) < .0001) {
          this.drawVideo(state, target);
          state.video.style.removeProperty('will-change');
          complete?.();
          return;
        }
        state.video.style.willChange = 'opacity, filter';
        const began = performance.now();
        const tick = (now) => {
          if (!this.isConnected) return;
          const elapsed = this.reducedMotion ? 1 : Math.min(1, (now - began) / duration);
          this.drawVideo(state, start + (target - start) * this.easing(elapsed, .42, .58));
          if (elapsed < 1) state.mediaFrame = requestAnimationFrame(tick);
          else {
            state.mediaFrame = null;
            state.video.style.removeProperty('will-change');
            complete?.();
          }
        };
        state.mediaFrame = requestAnimationFrame(tick);
      }

      cancelVideoReset(state) {
        state.resetCleanup?.();
        state.resetCleanup = null;
        cancelAnimationFrame(state.rewindFrame);
        state.rewindFrame = null;
        state.resetting = false;
      }

      rewindVideo(state) {
        if (state.resetting) return;
        state.resetting = true;
        state.restartPending = false;
        this.fadeVideo(state, 0, this.number('videoFadeMs', 600), () => {
          const video = state.video;
          let requested = false;
          let finished = false;
          const events = ['loadedmetadata', 'seeked', 'loadeddata', 'canplay'];
          const cleanup = () => {
            finished = true;
            events.forEach((name) => video.removeEventListener(name, ready));
            cancelAnimationFrame(state.rewindFrame);
            state.rewindFrame = null;
          };
          const ready = () => {
            if (finished || !this.isConnected) return;
            if (!requested) {
              if (video.readyState < 1) return;
              requested = true;
              state.lastTime = 0;
              try {
                if (video.currentTime !== 0 || video.ended) video.currentTime = 0;
              } catch (error) {
                requested = false;
                return;
              }
            }
            if (video.seeking || video.readyState < 2 || state.rewindFrame !== null) return;
            state.rewindFrame = requestAnimationFrame(() => {
              state.rewindFrame = requestAnimationFrame(() => {
                state.rewindFrame = null;
                if (finished || video.seeking || video.readyState < 2 || video.currentTime > .05) return;
                cleanup();
                state.resetCleanup = null;
                state.resetting = false;
                if (state !== this.activeVideo || !this.busy) {
                  this.fadeVideo(state, 1, this.number('videoFadeMs', 600));
                }
                if (state === this.activeVideo) this.schedule();
              });
            });
          };
          state.resetCleanup = cleanup;
          events.forEach((name) => video.addEventListener(name, ready));
          ready();
        });
      }

      resetVideo(state, immediate = false) {
        this.pauseVideo(state);
        state.readyToAdvance = false;
        state.restartPending = false;
        state.elapsed = 0;
        state.lastTime = 0;
        if (immediate) {
          this.cancelVideoReset(state);
          this.fadeVideo(state, 0, 0);
          try { state.video.currentTime = 0; } catch (error) {}
          this.drawVideo(state, 1);
          return;
        }
        this.rewindVideo(state);
      }

      syncVideo() {
        const state = this.activeVideo;
        if (!state) return;
        this.updateVideoButton(state);
        if (state.failed || state.blocked || this.shouldPauseVideo(state)) {
          this.pauseVideo(state);
          return;
        }
        if (state.resetting) return;
        if (state.restartPending) {
          if (this.busy) return;
          this.pauseVideo(state);
          this.rewindVideo(state);
          return;
        }
        if (!state.video.paused || state.starting) return;
        state.starting = true;
        const attempt = ++state.attempt;
        Promise.resolve(state.video.play()).then(() => {
          if (attempt !== state.attempt) return;
          state.starting = false;
          if (state !== this.activeVideo || this.shouldPauseVideo(state)) this.pauseVideo(state);
        }).catch((error) => {
          if (attempt !== state.attempt) return;
          state.starting = false;
          if (state !== this.activeVideo || this.shouldPauseVideo(state)) return;
          if (error.name === 'NotAllowedError' || error.name === 'AbortError') {
            state.blocked = true;
            this.updateVideoButton(state);
          } else {
            state.failed = true;
            this.schedule();
          }
        });
      }

      finishVideo(state) {
        if (state !== this.activeVideo || this.busy || state.readyToAdvance || state.failed) return;
        state.readyToAdvance = true;
        this.schedule();
      }

      recordVideoTime(state) {
        const time = state.video.currentTime;
        if (!Number.isFinite(time)) return;
        state.elapsed += Math.max(0, time - state.lastTime);
        state.lastTime = time;
      }

      videoEnded(state) {
        if (state !== this.activeVideo || state.failed) return;
        this.recordVideoTime(state);
        if (!state.timed || state.elapsed >= state.seconds) state.readyToAdvance = true;
        state.restartPending = true;
        this.schedule();
      }

      updateVideoButton(state) {
        if (!state.button) return;
        state.button.hidden = state !== this.activeVideo || state.failed ||
          !(state.blocked || ((this.reducedMotion || this.focused) && !state.userStarted));
        state.button.querySelector('[data-video-play-text]').textContent = this.dataset.videoPlayLabel;
      }

      pauseOnHover() {
        return this.activeVideo ? this.dataset.videoPauseHover === 'true' : this.dataset.pauseHover === 'true';
      }

      canAdvance() {
        const autoplay = this.activeVideo ? this.dataset.videoAutoplay !== 'false' : this.dataset.autoplay === 'true';
        return this.isConnected && autoplay && this.originals.length > 1 &&
          !this.busy && !this.paused && !this.focused && !this.touch && !this.editorPaused && this.inView &&
          !this.reducedMotion && !document.hidden && !(this.hovered && this.pauseOnHover());
      }

      updatePause() {
        if (!this.pauseButton) return;
        const label = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.pauseButton.textContent = label;
        this.pauseButton.setAttribute('aria-label', label);
      }

      schedule(delay) {
        this.stopAutoplay();
        if (this.activeVideo && !this.activeVideo.failed && this.activeVideo.readyToAdvance && this.canAdvance()) {
          this.go(1);
          return;
        }
        this.syncVideo();
        if (!this.canAdvance()) return;
        if (this.activeVideo && !this.activeVideo.failed) return;
        this.timer = window.setTimeout(() => this.go(1), delay === undefined ? this.number('delay', 3000) : delay);
      }

      stopAutoplay() {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }
    customElements.define('vusi-image-card-stack', VusiImageCardStack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neo-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vusi-image-carousel')) {
    const vusiPlayback = window.VusiLoop || { play: video => Promise.resolve(video.play()), pause: video => video.pause(), paused: video => video.paused };
  customElements.define('vusi-image-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.visible = false;
      this.hovered = false;
      this.touching = false;
      this.editorSelected = false;
      this.animating = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, {...options, signal: this.controller.signal});
      this.track = this.querySelector('.vic__track');
      this.originals = [...this.track.querySelectorAll('[data-card]')];
      this.captionText = this.querySelector('[data-caption-text]');
      this.captionWidth = this.querySelector('[data-caption-width]');
      this.captionValue = undefined;
      this.dots = [...this.querySelectorAll('.vic__dot')];
      if (!this.originals.length) return;
      this.index = Math.min(Number(this.dataset.start) || 0, this.originals.length - 1);
      this.loop = this.dataset.loop === 'true' && this.originals.length > 1;
      if (this.loop) {
        const copy = card => {
          const clone = card.cloneNode(true);
          clone.dataset.clone = 'true';
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          clone.querySelectorAll('a,button').forEach(el => el.tabIndex = -1);
          return clone;
        };
        this.track.prepend(...this.originals.map(copy));
        this.track.append(...this.originals.map(copy));
      }
      this.cards = [...this.track.querySelectorAll('[data-card]')];
      this.videos = [...this.querySelectorAll('.vic__video:not([data-vusi-loop-copy])')];
      this.videoPending = new Set();
      this.videoWanted = new Set();
      this.videoWarm = new Set();
      this.videoNear = false;
      this.videoApproaching = false;
      this.videos.forEach(video => {
        video.defaultMuted = true;
        video.muted = true;
        video.volume = 0;
        video.loop = true;
        video.setAttribute('disableremoteplayback', '');
        video.playsInline = true;
        on(video, 'loadeddata', () => this.playVideo(video));
        on(video, 'canplay', () => this.playVideo(video));
      });
      this.videoPreloadObserver = new IntersectionObserver(entries => {
        this.videoNear = entries[0].isIntersecting;
        this.queueVideos();
      }, {rootMargin:'600px 0px'});
      this.videoPlayObserver = new IntersectionObserver(entries => {
        this.videoApproaching = entries[0].isIntersecting;
        this.queueVideos();
      }, {rootMargin:'0px 0px'});
      this.videoPreloadObserver.observe(this);
      this.videoPlayObserver.observe(this);
      on(this.track, 'scroll', () => this.queueVideos(), {passive:true});
      on(document, 'visibilitychange', () => this.queueVideos());
      on(this.motion, 'change', () => this.queueVideos());

      this.jump(this.originals[this.index]);
      this.update();
      on(this.track, 'scroll', () => {
        if (this.jumping || this.animating) return;
        this.clearAuto();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 130);
      }, {passive: true});
      on(this.track, 'scrollend', () => this.settle());
      this.dots.forEach(dot => on(dot, 'click', () => this.go(Number(dot.dataset.index))));
      on(this.track, 'keydown', e => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        this.go(e.key === 'Home' ? 0 : e.key === 'End' ? this.originals.length - 1 : this.index + (e.key === 'ArrowRight' ? 1 : -1));
      });
      on(this.track, 'pointerdown', e => {
        this.touching = true;
        this.clearAuto();
        this.stopAnimation();
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        this.drag = {x: e.clientX, scroll: this.track.scrollLeft, id: e.pointerId};
        this.moved = false;
      });
      on(window, 'pointermove', e => {
        if (!this.drag) return;
        const delta = e.clientX - this.drag.x;
        if (Math.abs(delta) > 5) {
          this.moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(this.drag.id);
          this.track.scrollLeft = this.drag.scroll - delta;
        }
      });
      const release = () => {
        if (!this.touching && !this.drag) return;
        this.touching = false;
        if (!this.drag) {this.scheduleAuto();return;}
        if (this.track.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
        this.drag = null;
        this.track.classList.remove('is-dragging');
        this.settle();
      };
      on(window, 'pointerup', release);
      on(window, 'pointercancel', release);
      on(this.track, 'click', e => {if(this.moved) {e.preventDefault();e.stopPropagation();this.moved=false;}}, {capture:true});
      on(this.track, 'dragstart', e => e.preventDefault());
      on(this, 'shopify:block:select', e => {
        this.editorSelected = true;
        this.clearAuto();
        const i = this.originals.findIndex(card => card.dataset.blockId === e.detail.blockId);
        if (i >= 0) {this.index=i;this.jump(this.originals[i]);this.update();}
      });
      on(this, 'shopify:block:deselect', () => {this.editorSelected=false;this.scheduleAuto();});
      on(this, 'mouseenter', () => {this.hovered=true;if(this.dataset.pauseHover==='true')this.clearAuto();});
      on(this, 'mouseleave', () => {this.hovered=false;this.scheduleAuto();});
      on(this, 'focusin', () => this.clearAuto());
      on(this, 'focusout', () => {
        clearTimeout(this.focusTimer);
        this.focusTimer=setTimeout(() => this.scheduleAuto(),0);
      });
      on(document, 'visibilitychange', () => this.scheduleAuto());
      on(this.motion, 'change', () => this.scheduleAuto());
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible=entries[0].isIntersecting;
        this.scheduleAuto();
      }, {threshold:0});
      this.visibilityObserver.observe(this);
      this.observer = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (width !== this.lastWidth) {this.lastWidth=width;this.jump(this.originals[this.index]);}
      });
      this.observer.observe(this.track);
    }
      updateCaption(text) {
        if (!this.captionText) return;
        if (this.captionValue === text) return;
        const segment = (value) => typeof Intl.Segmenter === 'function'
          ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value), (part) => part.segment)
          : Array.from(value);
        const oldNodes = Array.from(this.captionText.children).filter((node) => !node.dataset.exiting);
        const before = oldNodes.map((node) => ({ node, text: node.textContent, x: node.offsetLeft, y: node.offsetTop }));
        const after = segment(text);
        const was = this.captionValue;
        this.captionValue = text;
        this.captionText.setAttribute('aria-label', text);
        this.captionText.querySelectorAll('[data-exiting]').forEach((node) => node.remove());
        this.captionText.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
        if (was === undefined || this.motion.matches || this.dataset.animateCaption === 'false') {
          this.captionText.replaceChildren(...after.map((character) => {
            const node = document.createElement('span');
            node.textContent = character;
            node.setAttribute('aria-hidden', 'true');
            return node;
          }));
          this.captionWidth.style.width = '';
          return;
        }
        const table = Array.from({ length: before.length + 1 }, () => Array(after.length + 1).fill(0));
        for (let i = 1; i <= before.length; i += 1) {
          for (let j = 1; j <= after.length; j += 1) {
            table[i][j] = before[i - 1].text === after[j - 1] ? table[i - 1][j - 1] + 1 : Math.max(table[i - 1][j], table[i][j - 1]);
          }
        }
        const matches = new Map();
        let i = before.length;
        let j = after.length;
        while (i > 0 && j > 0) {
          if (before[i - 1].text === after[j - 1]) { matches.set(j - 1, before[i - 1]); i -= 1; j -= 1; }
          else if (table[i - 1][j] > table[i][j - 1] || (table[i - 1][j] === table[i][j - 1] && i >= j)) i -= 1;
          else j -= 1;
        }
        const retained = new Set(Array.from(matches.values(), (entry) => entry.node));
        const ratio = (before.length + after.length - matches.size * 2) / Math.max(1, before.length, after.length);
        const options = { duration: Number(this.dataset.captionSpeed) || 380, easing: 'cubic-bezier(.19,1,.22,1)' };
        const removed = before.filter((entry) => !retained.has(entry.node));
        const nodes = after.map((character, index) => {
          const node = matches.get(index)?.node || document.createElement('span');
          node.textContent = character;
          node.setAttribute('aria-hidden', 'true');
          return node;
        });
        this.captionText.replaceChildren(...nodes);
        nodes.forEach((node, index) => {
          const match = matches.get(index);
          const drift = (after.length <= 1 ? 0 : index / (after.length - 1) - .5) * 15 * ratio;
          node.animate(match
            ? [{ transform: 'translate(' + (match.x - node.offsetLeft) + 'px,' + (match.y - node.offsetTop) + 'px)' }, { transform: 'translateX(0)' }]
            : [{ opacity: 0, filter: 'blur(' + (Number(this.dataset.captionBlur) || 0) + 'px)', transform: 'translateX(' + drift + 'px) scale(.85)' }, { opacity: 1, filter: 'blur(0)', transform: 'translateX(0) scale(1)' }], options);
        });
        removed.forEach(({ node, x, y }) => {
          node.dataset.exiting = 'true';
          node.style.position = 'absolute';
          node.style.left = x + 'px';
          node.style.top = y + 'px';
          this.captionText.append(node);
          const animation = node.animate([{ opacity: 1, filter: 'blur(0)', transform: 'scale(1)' }, { opacity: 0, filter: 'blur(' + (Number(this.dataset.captionBlur) || 0) + 'px)', transform: 'scale(.85)' }], { ...options, fill: 'forwards' });
          animation.finished.then(() => node.remove()).catch(() => node.remove());
        });
      }

    queueVideos() {
      if (!this.videoFrame) this.videoFrame = requestAnimationFrame(() => {
        this.videoFrame = 0;
        this.updateVideos();
      });
    }
    playVideo(video) {
      if (!this.isConnected || !this.videoWanted.has(video) || !vusiPlayback.paused(video) || this.videoPending.has(video)) return;
      this.videoPending.add(video);
      vusiPlayback.play(video).catch(() => {}).finally(() => {
        this.videoPending.delete(video);
        if (!this.isConnected || !this.videoWanted.has(video)) vusiPlayback.pause(video);
      });
    }
    updateVideos() {
      if (!this.videos) return;
      const bounds = this.track.getBoundingClientRect();
      this.videos.forEach(video => {
        const rect = video.closest('.vic__card').getBoundingClientRect();
        const near = rect.right > bounds.left - rect.width - 32 && rect.left < bounds.right + rect.width + 32;
        if (this.videoNear && near && !this.videoWarm.has(video)) {
          this.videoWarm.add(video);
          video.preload = 'auto';
          if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) video.load();
        }
        if (this.videoApproaching && rect.right > bounds.left && rect.left < bounds.right && !document.hidden && !this.motion.matches) {
          this.videoWanted.add(video);
          this.playVideo(video);
        } else {
          this.videoWanted.delete(video);
          vusiPlayback.pause(video);
        }
      });
    }
    center(card) {return card.offsetLeft + card.offsetWidth / 2 - this.track.clientWidth / 2;}
    jump(card) {
      this.stopAnimation();
      this.jumping = true;
      this.track.classList.add('is-jumping');
      this.track.scrollLeft = this.center(card);
      this.queueVideos();
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {this.track.classList.remove('is-jumping');this.jumping=false;this.scheduleAuto();});
    }
    nearest() {return this.cards.reduce((a,b) => Math.abs(this.center(a)-this.track.scrollLeft)<Math.abs(this.center(b)-this.track.scrollLeft)?a:b);}
    settle() {
      if (this.drag || this.touching || this.jumping || this.animating) return;
      clearTimeout(this.settleTimer);
      const card = this.nearest();
      this.index = Number(card.dataset.card);
      this.update();
      if (card.dataset.clone) this.jump(this.originals[this.index]);
      this.scheduleAuto();
    }
    update() {this.dots.forEach(dot => dot.setAttribute('aria-pressed', String(Number(dot.dataset.index) === this.index)));this.updateCaption(this.originals[this.index]?.dataset.caption || '');}
    go(index) {
      this.clearAuto();
      this.stopAnimation();
      const count = this.originals.length;
      const target = this.loop ? (index + count) % count : Math.max(0, Math.min(index, count-1));
      const choices = this.cards.filter(card => Number(card.dataset.card) === target);
      const card = choices.reduce((a,b) => Math.abs(this.center(a)-this.track.scrollLeft)<Math.abs(this.center(b)-this.track.scrollLeft)?a:b);
      this.index = target;
      this.update();
      const start = this.track.scrollLeft;
      const distance = this.center(card) - start;
      const duration = this.motion.matches ? 0 : Number(this.dataset.duration) || 800;
      if (!duration || Math.abs(distance)<1) {this.jump(card);this.scheduleAuto();return;}
      this.animating = true;
      cancelAnimationFrame(this.frame);
      this.jumping = false;
      this.track.classList.add('is-jumping');
      const started = performance.now();
      const tick = now => {
        const t = Math.min(1, (now-started)/duration);
        const eased = t<0.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2;
        this.track.scrollLeft = start + distance*eased;
        if(t<1) {this.animationFrame=requestAnimationFrame(tick);return;}
        this.animating = false;
        this.track.classList.remove('is-jumping');
        this.settle();
      };
      this.animationFrame=requestAnimationFrame(tick);
    }
    stopAnimation() {
      cancelAnimationFrame(this.animationFrame);
      this.animating = false;
      this.track.classList.remove('is-jumping');
    }
    clearAuto() {clearTimeout(this.autoTimer);}
    scheduleAuto() {
      this.clearAuto();
      if (!this.isConnected || this.dataset.autoplay!=='true' || this.originals.length<2 ||
          !this.visible || document.hidden || this.motion.matches || this.touching || this.drag ||
          this.animating || this.jumping || this.editorSelected || this.contains(document.activeElement) ||
          (this.dataset.pauseHover==='true' && this.hovered)) return;
      if (!this.loop && this.index===this.originals.length-1) return;
      this.autoTimer=setTimeout(() => this.go(this.index+1), Math.max(1000,Number(this.dataset.interval)||5000));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.videoFrame);this.videoFrame=0;
      this.videoPreloadObserver?.disconnect();this.videoPlayObserver?.disconnect();
      this.videoWanted?.clear();this.videos?.forEach(video => vusiPlayback.pause(video));
      this.clearAuto();this.stopAnimation();this.visibilityObserver?.disconnect();clearTimeout(this.focusTimer);
      this.controller?.abort();this.observer?.disconnect();clearTimeout(this.settleTimer);cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-clone]').forEach(card => card.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neo-hardware"] && !Shopify.designMode) return;
  try {
    
  const initializeNeoHardware = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const targets = root.querySelectorAll('.neo-hardware__header, .neo-hardware__group-shell');

    if (root.dataset.reveal !== 'true' || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    root.classList.add('is-reveal-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    targets.forEach((target) => observer.observe(target));
  };

  document.querySelectorAll('[data-neo-hardware]').forEach(initializeNeoHardware);

  document.addEventListener('shopify:section:load', (event) => {
    initializeNeoHardware(event.target.querySelector('[data-neo-hardware]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vusi-contact')) {
    customElements.define('vusi-contact', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const link = event.target.closest('[data-vct-scroll]');
        if (!link) return;
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        const target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        if (history.pushState) history.pushState(null, '', href);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-button"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seed-sticky-product')) {
  customElements.define('seed-sticky-product', class extends HTMLElement {
    static pageDismissals = new Set();

    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.lifecycle = new AbortController();
      this.frame = 0;
      this.startedAt = Date.now();
      this.lastScroll = Math.max(0, window.scrollY);
      this.scrollDirection = 'down';
      this.hasAppeared = false;
      this.editorSelected = false;
      this.busy = false;
      this.variant = this.querySelector('[data-variant]');
      this.plan = this.querySelector('[data-plan]');
      this.plans = this.querySelector('[data-plans]');
      this.form = this.querySelector('[data-form]');
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.prepareTitle();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.dismissalKey = `seed-sticky-product:${encodeURIComponent(this.dataset.sectionId || this.id)}:${encodeURIComponent(this.dataset.productUrl || '')}`;
      this.dismissed = this.readDismissal();
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (!this.connected || this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.evaluate();
        });
      };
      const options = { signal: this.lifecycle.signal };
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) {
          window.clearTimeout(this.motionTimer);
          this.dataset.motion = this.dataset.visible === 'true' ? 'visible' : 'hidden';
        }
        this.schedule();
      }, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, { ...options, passive: true });
      window.addEventListener('pageshow', this.schedule, options);
      this.mobileQuery.addEventListener('change', this.schedule, options);
      this.querySelector('[data-close]')?.addEventListener('click', () => this.dismiss(), options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || this.dataset.dismissible !== 'true' || this.dataset.visible !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
        this.dismiss();
      }, options);
      this.variant?.addEventListener('change', () => {
        this.clearStatus();
        this.updateVariant();
      }, options);
      this.plan?.addEventListener('change', () => {
        this.clearStatus();
        this.updatePurchase();
      }, options);
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addToCart();
      }, options);
      if (this.dataset.editor === 'true') {
        document.addEventListener('shopify:section:select', (event) => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          this.editorSelected = true;
          this.schedule();
        }, options);
        document.addEventListener('shopify:section:deselect', (event) => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          this.editorSelected = false;
          this.schedule();
        }, options);
      }
      this.mutations = new MutationObserver((records) => {
        if (records.some((record) => !this.contains(record.target))) this.schedule();
      });
      this.mutations.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['open', 'class', 'hidden', 'aria-hidden', 'style']
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.measureMotion();
          this.schedule();
        });
        this.resizeObserver.observe(document.documentElement);
        if (document.body) this.resizeObserver.observe(document.body);
        if (this.querySelector('.ssp__main')) this.resizeObserver.observe(this.querySelector('.ssp__main'));
      }
      const delay = this.number('delay', 0, 0, 3600) * 1000;
      if (delay) this.delayTimer = window.setTimeout(this.schedule, delay + 20);
      this.setVisible(false);
      this.hidden = false;
      this.measureMotion();
      this.updateVariant();
      this.evaluate();
    }

    disconnectedCallback() {
      this.connected = false;
      this.lifecycle?.abort();
      this.requestController?.abort();
      this.mutations?.disconnect();
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.frame);
      window.clearTimeout(this.delayTimer);
      window.clearTimeout(this.motionTimer);
      this.frame = 0;
    }

    number(key, fallback, min, max) {
      const raw = this.dataset[key];
      const value = raw === undefined || raw === '' ? fallback : Number(raw);
      return Math.min(max, Math.max(min, Number.isFinite(value) ? value : fallback));
    }

    queryPage(selector) {
      if (!selector?.trim()) return [];
      try {
        return Array.from(document.querySelectorAll(selector)).filter((element) => element !== this && !this.contains(element));
      } catch {
        return [];
      }
    }

    isOnScreen(element) {
      if (element.closest('[hidden], [aria-hidden="true"]')) return false;
      if (element.tagName === 'DIALOG' && !element.open) return false;
      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
    }

    evaluate() {
      if (!this.connected) return;
      const scroll = Math.max(0, window.scrollY);
      if (Math.abs(scroll - this.lastScroll) > 2) {
        this.scrollDirection = scroll > this.lastScroll ? 'down' : 'up';
        this.lastScroll = scroll;
      }
      const preview = this.dataset.editor === 'true' && (this.dataset.preview === 'true' || this.editorSelected);
      if (preview) {
        this.setVisible(true);
        return;
      }
      const mobile = this.mobileQuery.matches;
      const correctDevice = this.dataset.device !== (mobile ? 'desktop' : 'mobile');
      const allSoldOut = this.variant && this.variant.options.length > 0 ? !Array.from(this.variant.options).some((option) => option.dataset.available !== 'false') : this.dataset.productAvailable === 'false';
      if (this.dataset.enabled === 'false' || this.dismissed || !correctDevice || (this.dataset.hideSoldout === 'true' && allSoldOut)) {
        this.setVisible(false);
        return;
      }
      const delayed = Date.now() - this.startedAt >= this.number('delay', 0, 0, 3600) * 1000;
      const threshold = this.number(mobile ? 'scrollMobile' : 'scrollDesktop', 600, 0, 1000000);
      let triggered = scroll >= threshold;
      if (this.dataset.trigger === 'always') triggered = true;
      if (this.dataset.trigger === 'viewport') triggered = scroll >= window.innerHeight * this.number('viewport', 105, 0, 1000) / 100;
      if (this.dataset.trigger === 'percent') {
        const height = Math.max(document.documentElement.scrollHeight, document.body?.scrollHeight || 0) - window.innerHeight;
        triggered = (height > 0 ? scroll / height * 100 : 0) >= this.number('percent', 25, 0, 100);
      }
      if (this.dataset.trigger === 'element') {
        const target = this.queryPage(this.dataset.triggerSelector)[0];
        if (target) triggered = target.getBoundingClientRect().bottom <= 0;
      }
      const direction = this.dataset.direction || 'both';
      const directionMatches = direction === 'both' || direction === this.scrollDirection;
      const remembered = this.dataset.once === 'true' && this.hasAppeared;
      let visible = delayed && (remembered || (triggered && directionMatches));
      if (visible && this.dataset.hideFooter === 'true') {
        visible = !this.queryPage(this.dataset.footerSelector || 'footer').some((element) => this.isOnScreen(element));
      }
      if (visible && this.dataset.hideOverlays === 'true') {
        visible = !this.queryPage(this.dataset.overlaySelector || 'dialog[open], [role="dialog"][aria-modal="true"]').some((element) => this.isOnScreen(element));
      }
      if (visible) this.hasAppeared = true;
      this.setVisible(visible);
    }

    prepareTitle() {
      const title = this.querySelector('.ssp__title');
      if (!title || title.querySelector('.ssp__title-words')) return;
      const text = title.textContent.trim();
      const accessible = document.createElement('span');
      accessible.className = 'ssp__sr-only';
      accessible.textContent = text;
      const words = document.createElement('span');
      words.className = 'ssp__title-words';
      words.setAttribute('aria-hidden', 'true');
      const parts = text.split(/\s+/u).filter(Boolean);
      parts.forEach((part, index) => {
        const mask = document.createElement('span');
        mask.className = 'ssp__word';
        const inner = document.createElement('span');
        inner.className = 'ssp__word-inner';
        inner.style.setProperty('--ssp-word-progress', parts.length > 1 ? index / (parts.length - 1) : 0);
        inner.textContent = part;
        mask.append(inner);
        words.append(mask);
      });
      title.replaceChildren(accessible, words);
    }

    measureMotion() {
      const panel = this.querySelector('[data-panel]');
      const row = this.querySelector('.ssp__main');
      if (!panel || !row || this.hidden) return;
      const style = window.getComputedStyle(panel);
      const diameter = row.offsetHeight + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const image = this.querySelector('.ssp__image-wrap');
      const travel = image && image.offsetWidth ? this.clientWidth - diameter / 2 - parseFloat(style.borderLeftWidth) - image.offsetLeft - image.offsetWidth / 2 : 0;
      const values = { '--ssp-pill-size': `${diameter}px`, '--ssp-image-travel': `${travel}px` };
      Object.entries(values).forEach(([property, value]) => {
        if (this.style.getPropertyValue(property) !== value) this.style.setProperty(property, value);
      });
    }

    setVisible(visible) {
      const value = visible ? 'true' : 'false';
      if (!visible && this.contains(document.activeElement)) document.activeElement.blur();
      if (this.inert === visible) this.inert = !visible;
      const ariaHidden = visible ? 'false' : 'true';
      if (this.getAttribute('aria-hidden') !== ariaHidden) this.setAttribute('aria-hidden', ariaHidden);
      if (this.dataset.visible === value) return;
      const previous = this.dataset.visible;
      window.clearTimeout(this.motionTimer);
      this.measureMotion();
      const duration = parseFloat(window.getComputedStyle(this).getPropertyValue('--ssp-duration')) || 900;
      const instant = this.reducedMotion?.matches || this.classList.contains('ssp--none');
      if ((!visible && previous === undefined) || instant) {
        this.dataset.motion = visible ? 'visible' : 'hidden';
        this.dataset.visible = value;
        return;
      }
      this.dataset.motion = visible ? 'entering' : 'exiting';
      this.dataset.visible = value;
      const multiplier = this.classList.contains('ssp--expand') ? visible ? 1.42 : 250 / 900 : 1;
      this.motionTimer = window.setTimeout(() => {
        if (this.connected && this.dataset.visible === value) this.dataset.motion = visible ? 'visible' : 'hidden';
      }, duration * multiplier + 34);
    }

    readDismissal() {
      if (this.constructor.pageDismissals.has(this.dismissalKey)) return true;
      try {
        if (this.dataset.dismissMemory === 'session') return sessionStorage.getItem(this.dismissalKey) === 'true';
        if (this.dataset.dismissMemory === 'days') {
          const expiry = Number(localStorage.getItem(this.dismissalKey));
          if (Number.isFinite(expiry) && expiry > Date.now()) return true;
          localStorage.removeItem(this.dismissalKey);
          return false;
        }
      } catch {}
      return this.constructor.pageDismissals.has(this.dismissalKey);
    }

    dismiss() {
      if (this.dataset.dismissible !== 'true') return;
      this.dismissed = true;
      this.constructor.pageDismissals.add(this.dismissalKey);
      try {
        if (this.dataset.dismissMemory === 'session') sessionStorage.setItem(this.dismissalKey, 'true');
        if (this.dataset.dismissMemory === 'days') localStorage.setItem(this.dismissalKey, String(Date.now() + this.number('dismissDays', 1, 1, 365) * 86400000));
      } catch {}
      this.setVisible(false);
    }

    updateVariant() {
      const variant = this.variant?.selectedOptions[0];
      if (this.plan) {
        const previous = this.plan.value;
        const template = Array.from(this.querySelectorAll('template[data-plans-for]')).find((element) => element.dataset.plansFor === this.variant?.value);
        this.plan.replaceChildren(...(template ? Array.from(template.content.cloneNode(true).childNodes) : []));
        if (Array.from(this.plan.options).some((option) => option.value === previous && !option.disabled)) this.plan.value = previous;
        const hasPlans = Array.from(this.plan.options).some((option) => option.value !== '');
        this.plan.disabled = !hasPlans;
        if (this.plans) this.plans.hidden = !hasPlans;
      }
      const image = this.querySelector('img[data-image]');
      if (image && image.dataset.customImage !== 'true' && variant?.dataset.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = variant.dataset.image;
      }
      this.updatePurchase();
      this.schedule();
    }

    updatePurchase() {
      const variant = this.variant?.selectedOptions[0];
      const plan = this.plan && !this.plan.disabled && this.plan.value ? this.plan.selectedOptions[0] : null;
      const prices = plan || variant;
      if (prices) {
        const price = this.querySelector('.ssp__prices [data-price]');
        const compare = this.querySelector('.ssp__prices [data-compare]');
        if (price) price.textContent = prices.dataset.price || variant?.dataset.price || '';
        if (compare) {
          compare.textContent = prices.dataset.compare || '';
          compare.hidden = !prices.dataset.compare;
        }
      }
      const soldOut = variant?.dataset.available === 'false';
      const requiresPlan = variant?.dataset.requiresPlan === 'true' && !plan;
      const large = this.dataset.largeProduct === 'true' && this.dataset.action !== 'link';
      const label = this.busy ? this.dataset.loading : large ? this.dataset.chooseOptions : soldOut && this.submit ? this.dataset.soldOut : requiresPlan && this.submit ? this.dataset.chooseOptions : this.dataset.cta;
      this.querySelectorAll('[data-button-text]').forEach((element) => {
        if (label !== undefined) element.textContent = label;
      });
      if (this.submit) {
        this.submit.disabled = this.busy || !variant || soldOut || requiresPlan;
        this.submit.setAttribute('aria-busy', this.busy ? 'true' : 'false');
      }
      this.querySelectorAll('[data-link]').forEach((link) => {
        const custom = this.dataset.action === 'link';
        const url = this.safeUrl(custom ? this.dataset.customUrl || this.dataset.productUrl : this.dataset.productUrl);
        if (!url) return;
        if (!custom && this.variant?.value) url.searchParams.set('variant', this.variant.value);
        link.href = url.href;
      });
    }

    safeUrl(value) {
      if (!value) return null;
      try {
        const url = new URL(value, window.location.origin);
        return ['http:', 'https:'].includes(url.protocol) ? url : null;
      } catch {
        return null;
      }
    }

    clearStatus() {
      if (this.status) {
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
      }
    }

    async addToCart() {
      if (this.busy || !this.submit || this.submit.disabled) return;
      const id = Number(this.variant?.value);
      const quantityInput = this.querySelector('[data-quantity]');
      const quantity = Number(quantityInput?.value || 1);
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.checkValidity())) {
        quantityInput?.reportValidity();
        return;
      }
      const item = { id, quantity };
      if (this.plan && !this.plan.disabled && this.plan.value) {
        const sellingPlan = Number(this.plan.value);
        if (!Number.isSafeInteger(sellingPlan) || sellingPlan <= 0) return;
        item.selling_plan = sellingPlan;
      }
      const addUrl = this.safeUrl(this.dataset.addUrl);
      if (!addUrl || addUrl.origin !== window.location.origin) return;
      this.busy = true;
      this.clearStatus();
      this.updatePurchase();
      const requestController = new AbortController();
      this.requestController = requestController;
      try {
        const response = await fetch(addUrl.href, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] }),
          signal: requestController.signal
        });
        let result;
        try { result = await response.json(); } catch { result = null; }
        if (!response.ok || result?.status >= 400 || !result) {
          const message = typeof result?.description === 'string' ? result.description : typeof result?.message === 'string' ? result.message : this.dataset.error;
          const error = new Error(message || 'Unable to add this item. Please try again.');
          error.name = 'CartResponseError';
          throw error;
        }
        if (!this.connected || this.requestController !== requestController) return;
        if (this.dataset.action === 'checkout') {
          const checkout = this.safeUrl(this.dataset.checkoutUrl);
          const cart = this.safeUrl(this.dataset.cartUrl || '/cart');
          if (checkout) window.location.assign(checkout.href);
          else if (cart) {
            cart.pathname = cart.pathname.replace(/\/cart\/?$/, '/checkout');
            cart.search = '';
            cart.hash = '';
            window.location.assign(cart.href);
          }
        } else if (this.dataset.afterAdd === 'cart') {
          const cart = this.safeUrl(this.dataset.cartUrl || '/cart');
          if (cart) window.location.assign(cart.href);
        } else {
          if (this.status) this.status.textContent = this.dataset.success || '';
          this.dispatchEvent(new CustomEvent('seed:cart-added', {
            bubbles: true,
            detail: { items: result.items || [result], sectionId: this.dataset.sectionId }
          }));
        }
      } catch (error) {
        if (error.name !== 'AbortError' && this.connected && this.requestController === requestController && this.status) {
          this.status.textContent = error.name === 'CartResponseError' ? error.message : this.dataset.error || 'Unable to add this item. Please try again.';
          this.status.setAttribute('data-error', 'true');
        }
      } finally {
        if (this.requestController === requestController) {
          this.busy = false;
          if (this.connected) this.updatePurchase();
        }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-briefing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vusi-reading-video')) {
  customElements.define('vusi-reading-video', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.player = this.querySelector('.vg-player');
      this.cover = this.querySelector('.vg-cover');
      this.playButton = this.querySelector('.vg-play');
      this.resetButton = this.querySelector('.vg-reset');
      this.error = this.querySelector('.vg-error');
      this.checkbox = this.querySelector('input');
      this.dialog = this.querySelector('dialog');
      this.dialog.querySelector('.vg-close').addEventListener('click', () => this.reset());
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.reset(); });
      this.dialog.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement === this.dialog) this.wasFullscreen = true;
        else if (this.wasFullscreen) { this.wasFullscreen = false; this.reset(); }
      });
      this.checkbox?.addEventListener('change', () => { this.playButton.disabled = !this.checkbox.checked; });
      this.playButton.addEventListener('click', () => this.start());
      this.resetButton.addEventListener('click', () => this.reset());
    }
    youtubeSource(raw) {
      let list = '', video = '';
      if (/^(PL|UU|LL|OLAK5uy_)[A-Za-z0-9_-]+$/.test(raw)) list = raw;
      else {
        const url = new URL(raw);
        if (!['youtube.com','www.youtube.com','m.youtube.com','youtu.be','www.youtube-nocookie.com'].includes(url.hostname)) throw new Error('Invalid host');
        list = url.searchParams.get('list') || '';
        video = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v') || '';
        if (!video && /^\/(embed|shorts)\//.test(url.pathname)) video = url.pathname.split('/')[2];
        if (video === 'videoseries') video = '';
      }
      if ((list && !/^[A-Za-z0-9_-]+$/.test(list)) || (video && !/^[A-Za-z0-9_-]{11}$/.test(video)) || (!list && !video)) throw new Error('Invalid YouTube link');
      const url = new URL('https://www.youtube-nocookie.com/embed/' + (video || 'videoseries'));
      url.searchParams.set('autoplay', window.matchMedia('(max-width: 749px)').matches ? '0' : '1'); url.searchParams.set('controls','1');
      url.searchParams.set('playsinline', window.matchMedia('(max-width: 749px)').matches ? '0' : '1'); url.searchParams.set('rel','0');
      if (list) { url.searchParams.set('listType','playlist'); url.searchParams.set('list',list); }
      if (this.dataset.loop === 'true') { url.searchParams.set('loop','1'); if (!list) url.searchParams.set('playlist',video); }
      return url.href;
    }
    start() {
      if (this.checkbox && !this.checkbox.checked) return;
      this.error.hidden = true;
      try {
        const raw = this.dataset.youtube.trim();
        let media;
        if (raw) {
          media = document.createElement('iframe');
          media.src = this.youtubeSource(raw);
          media.title = this.dataset.title;
          media.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          media.allowFullscreen = true;
          media.referrerPolicy = 'strict-origin-when-cross-origin';
        } else {
          media = this.querySelector('template').content.querySelector('video')?.cloneNode(true);
          if (!media) throw new Error('Missing video');
          media.addEventListener('error', () => { this.reset(); this.error.hidden = false; }, {once:true});
        }
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        this.player.replaceChildren(media);
        if (mobile && media.tagName === 'VIDEO') {
          media.autoplay = false;
          media.removeAttribute('autoplay');
          media.playsInline = false;
          media.removeAttribute('playsinline');
          media.removeAttribute('webkit-playsinline');
          media.preload = 'metadata';
          media.addEventListener('play', () => {
            if (!window.matchMedia('(max-width: 749px)').matches) return;
            try {
              if (media.webkitEnterFullscreen && !media.webkitDisplayingFullscreen) media.webkitEnterFullscreen();
              else if (media.requestFullscreen && document.fullscreenElement !== media) media.requestFullscreen().catch(() => {});
            } catch (_) {}
          });
        }
        this.player.inert = false;
        this.setAttribute('data-playing','');
        this.cover.inert = true;
        this.resetButton.hidden = false;
        media.tabIndex = 0;
        media.focus({preventScroll:true});
        if (!mobile && media.tagName === 'VIDEO') media.play().catch(() => {});
      } catch (_) { this.error.hidden = false; }
    }
    reset() {
      const dialogVideo = this.dialog.querySelector('video');
      dialogVideo?.pause();
      this.wasFullscreen = false;
      if (document.fullscreenElement === this.dialog) document.exitFullscreen().catch(() => {});
      this.dialog.close();
      this.dialog.querySelector('.vg-fullscreen-media').replaceChildren();
      this.player.querySelector('video')?.pause();
      this.player.replaceChildren();
      this.player.inert = true;
      this.removeAttribute('data-playing');
      this.cover.inert = false;
      this.resetButton.hidden = true;
      if (this.checkbox) { this.checkbox.checked = false; this.playButton.disabled = true; this.checkbox.focus({preventScroll:true}); }
      else this.playButton.focus({preventScroll:true});
    }
    disconnectedCallback() {
      this.player?.querySelector('video')?.pause();
      this.dialog?.querySelector('video')?.pause();
      this.dialog?.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vusi-animated-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vusi-animated-intro')) {
    customElements.define('vusi-animated-intro', class extends HTMLElement {
      connectedCallback() {
        if (this.controller && !this.controller.signal.aborted) return;
        this.controller = new AbortController();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.wasRevealed = false;
        this.selectedInEditor = false;
        this.dataset.vstState = 'visible';
        const signal = this.controller.signal;
        this.initialFrame = requestAnimationFrame(() => {
          if (!this.isConnected || signal.aborted) return;
          this.initialize(signal);
        });
      }
      initialize(signal) {
        if (this.dataset.animation !== 'true' || this.motionQuery.matches || !('IntersectionObserver' in window)) return;
        try {
          this.buildLines();
          this.dataset.vstState = 'waiting';
          this.classList.add('vst-intro--enhanced');
          this.offsetHeight;
          this.observeVisibility();
          this.lastWidth = this.querySelector('.vst-intro__content').getBoundingClientRect().width;
          this.resizeObserver = new ResizeObserver(() => {
            const width = this.querySelector('.vst-intro__content').getBoundingClientRect().width;
            if (Math.abs(width - this.lastWidth) < .5) return;
            this.lastWidth = width;
            this.scheduleLines();
          });
          this.resizeObserver.observe(this.querySelector('.vst-intro__content'));
          window.addEventListener('resize', () => {
            cancelAnimationFrame(this.observerFrame);
            this.observerFrame = requestAnimationFrame(() => this.observeVisibility());
          }, { signal, passive: true });
          this.addEventListener('focusin', () => this.reveal(true), { signal });
          this.motionQuery.addEventListener('change', event => { if (event.matches) this.reveal(true); }, { signal });
          document.addEventListener('shopify:section:select', event => {
            if (event.target === this || event.target.contains(this)) {
              this.selectedInEditor = true;
              this.reveal(true);
            }
          }, { signal });
          document.addEventListener('shopify:section:deselect', event => {
            if (event.target === this || event.target.contains(this)) this.selectedInEditor = false;
          }, { signal });
          if (document.fonts) {
            document.fonts.ready.then(() => { if (this.isConnected && !signal.aborted) this.scheduleLines(); });
            document.fonts.addEventListener('loadingdone', () => this.scheduleLines(), { signal });
          }
        } catch (_) {
          this.restoreFallback();
        }
      }
      renderedLines(source) {
        const textNode = source.firstChild;
        if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return [source.textContent];
        const text = textNode.textContent;
        const range = document.createRange();
        const lines = [];
        let current = '';
        let lineTop = null;
        let offset = 0;
        for (const character of text) {
          if (character === '\n') {
            lines.push(current.trim());
            current = '';
            lineTop = null;
            offset += character.length;
            continue;
          }
          range.setStart(textNode, offset);
          range.setEnd(textNode, offset + character.length);
          const rect = range.getClientRects()[0];
          if (rect && rect.width > 0 && character.trim()) {
            if (lineTop !== null && Math.abs(rect.top - lineTop) > 2) {
              lines.push(current.trim());
              current = '';
            }
            lineTop = rect.top;
          }
          current += character;
          offset += character.length;
        }
        if (current || !lines.length) lines.push(current.trim());
        return lines;
      }
      buildLines() {
        let step = 0;
        const stagger = Math.max(0, Number(this.dataset.stagger) || 0);
        const startDelay = Math.max(0, Number(this.dataset.startDelay) || 0);
        this.querySelectorAll('[data-vst-text]').forEach(element => {
          const source = element.querySelector('[data-vst-source]');
          const lines = this.renderedLines(source);
          let visual = element.querySelector('.vst-intro__lines');
          if (!visual) {
            visual = document.createElement('span');
            visual.className = 'vst-intro__lines';
            visual.setAttribute('aria-hidden', 'true');
            element.append(visual);
          }
          const signature = JSON.stringify(lines);
          if (visual.dataset.signature === signature) {
            visual.querySelectorAll('.vst-intro__line-inner').forEach(inner => inner.style.setProperty('--vst-delay', `${startDelay + step++ * stagger}ms`));
            return;
          }
          visual.dataset.signature = signature;
          const fragment = document.createDocumentFragment();
          lines.forEach(text => {
            const line = document.createElement('span');
            line.className = 'vst-intro__line';
            const inner = document.createElement('span');
            inner.className = 'vst-intro__line-inner';
            inner.textContent = text || '\u00a0';
            inner.style.setProperty('--vst-delay', `${startDelay + step++ * stagger}ms`);
            line.append(inner);
            fragment.append(line);
          });
          visual.replaceChildren(fragment);
        });
        this.querySelectorAll('[data-vst-button]').forEach(button => button.style.setProperty('--vst-delay', `${startDelay + step++ * stagger}ms`));
      }
      scheduleLines() {
        cancelAnimationFrame(this.lineFrame);
        this.lineFrame = requestAnimationFrame(() => {
          if (!this.isConnected || this.controller.signal.aborted) return;
          try { this.buildLines(); } catch (_) { this.restoreFallback(); }
        });
      }
      observeVisibility() {
        this.observer?.disconnect();
        if (!this.isConnected || this.controller.signal.aborted || this.wasRevealed && this.dataset.replay !== 'true') return;
        const trigger = Number(this.dataset.trigger);
        const inset = Math.min(40, Math.max(0, Number.isFinite(trigger) ? trigger : 12));
        const margin = Math.round(window.innerHeight * inset / 100);
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (this.selectedInEditor) continue;
            if (entry.isIntersecting) this.reveal();
            else if (this.dataset.replay === 'true' && this.wasRevealed && !this.motionQuery.matches) this.dataset.vstState = 'waiting';
          }
        }, { rootMargin: `0px 0px -${margin}px 0px`, threshold: 0 });
        this.observer.observe(this);
      }
      reveal(instant = false) {
        this.dataset.vstInstant = String(instant || this.motionQuery.matches);
        this.dataset.vstState = 'visible';
        this.wasRevealed = true;
        if (this.dataset.replay !== 'true') this.observer?.disconnect();
      }
      restoreFallback() {
        this.cleanup();
        this.classList.remove('vst-intro--enhanced');
        this.querySelectorAll('.vst-intro__lines').forEach(element => element.remove());
        this.dataset.vstState = 'visible';
      }
      cleanup() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.initialFrame);
        cancelAnimationFrame(this.lineFrame);
        cancelAnimationFrame(this.observerFrame);
      }
      disconnectedCallback() {
        this.cleanup();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vusi-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vusi-faq')) {
    customElements.define('vusi-faq', class extends HTMLElement {
      connectedCallback() {
        this.handleSummaryClick = this.handleSummaryClick.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.closeTimers = new WeakMap();
        this.items = [...this.querySelectorAll('.vf-item')];
        this.items.forEach((item, index) => {
          item.style.setProperty('--vf-item-index', index);
          this.updateAnswerHeight(item);
          item.querySelector('.vf-summary')?.addEventListener('click', this.handleSummaryClick);
        });
        this.startEntranceAnimation();
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      disconnectedCallback() {
        this.items?.forEach((item) => item.querySelector('.vf-summary')?.removeEventListener('click', this.handleSummaryClick));
        this.observer?.disconnect();
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      startEntranceAnimation() {
        if (this.dataset.animateOnScroll !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) {
          this.classList.add('vf-is-visible');
          return;
        }
        this.observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          this.classList.add('vf-is-visible');
          this.observer.disconnect();
        }, { threshold: 0.12 });
        this.observer.observe(this);
      }

      updateAnswerHeight(item) {
        const panel = item.querySelector('.vf-answer-panel');
        if (panel) item.style.setProperty('--vf-answer-height', `${panel.scrollHeight}px`);
      }

      openItem(item) {
        const pendingClose = this.closeTimers.get(item);
        if (pendingClose) window.clearTimeout(pendingClose);
        this.updateAnswerHeight(item);
        item.classList.remove('vf-is-closing');
        item.setAttribute('open', '');
        if (this.dataset.singleOpen !== 'true') return;
        this.items.forEach((other) => {
          if (other !== item && other.open) this.closeItem(other);
        });
      }

      closeItem(item) {
        if (!item.open || item.classList.contains('vf-is-closing')) return;
        item.classList.add('vf-is-closing');
        const timer = window.setTimeout(() => {
          item.removeAttribute('open');
          item.classList.remove('vf-is-closing');
          this.closeTimers.delete(item);
        }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500);
        this.closeTimers.set(item, timer);
      }

      handleSummaryClick(event) {
        event.preventDefault();
        const item = event.currentTarget.closest('.vf-item');
        if (!item) return;
        item.open && !item.classList.contains('vf-is-closing') ? this.closeItem(item) : this.openItem(item);
      }

      handleBlockSelect(event) {
        const item = event.target.closest?.('.vf-item');
        if (item && this.contains(item)) this.openItem(item);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vusi-glide-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vusi-balanced-product')) {
  customElements.define('vusi-balanced-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.frame = requestAnimationFrame(() => {
        const details = this.querySelector('.product-details');
        const track = this.querySelector('.vusi-product-gallery__track');
        if (!details || !track) return;
        const update = () => {
          if (!this.isConnected || !matchMedia('(min-width:750px)').matches) return;
          const open = details.querySelectorAll('details[open]');

          if (open.length && this.style.getPropertyValue('--matched-gallery-height')) return;
          let height = details.getBoundingClientRect().height;
          open.forEach(drawer => {
            const content = drawer.querySelector('.details-content');
            if (content) height -= content.getBoundingClientRect().height;
          });
          if (height > 0) this.style.setProperty('--matched-gallery-height', `${height}px`);
          const count = track.querySelectorAll(':scope > .vusi-product-media').length;
          this.style.setProperty('--gallery-small-rows', Math.max(0, Math.ceil((count - 1) / 2)));
        };


        const schedule = () => {
          clearTimeout(this.measureTimer);
          this.measureTimer = setTimeout(update, 180);
        };
        this.resize = new ResizeObserver(schedule);
        this.resize.observe(details);
        this.changes = new MutationObserver(schedule);
        this.changes.observe(track, {childList:true});
        window.addEventListener('resize', schedule, {signal});
        details.addEventListener('toggle', schedule, {capture:true,signal});
        document.fonts.ready.then(() => { if (!signal.aborted) update(); });
        update();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.measureTimer);
      this.controller?.abort();
      this.resize?.disconnect();
      this.changes?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vusi-launch-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vusi-launch-signup')) {
    customElements.define('vusi-launch-signup', class extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this.editorSelected = false;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleMotionChange = () => this.scheduleReveal();
        this.handleSectionSelect = event => {
          if (!(event.target instanceof Element) || !event.target.contains(this)) return;
          this.editorSelected = true;
          cancelAnimationFrame(this.revealFrame);
          this.revealFrame = null;
          this.observer?.disconnect();
          this.classList.remove('vst-signup--ready');
          this.classList.add('vst-signup--revealed');
        };
        this.motionPreference.addEventListener('change', this.handleMotionChange);
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        this.scheduleReveal();
      }

      scheduleReveal() {
        cancelAnimationFrame(this.revealFrame);
        this.revealFrame = requestAnimationFrame(() => {
          this.revealFrame = null;
          if (this.isConnected && this._connected) this.initializeReveal();
        });
      }

      initializeReveal() {
        this.observer?.disconnect();
        this.classList.remove('vst-signup--ready', 'vst-signup--revealed');
        if (this.editorSelected || this.dataset.animate !== 'true' || this.motionPreference.matches || !('IntersectionObserver' in window) || this.querySelector('[data-form-feedback]')) return;
        this.classList.add('vst-signup--ready');
        void window.getComputedStyle(this.querySelector('[data-vst-reveal]') || this).opacity;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio >= 0.12) {
              this.classList.add('vst-signup--revealed');
              if (this.dataset.repeat !== 'true') this.observer.disconnect();
            } else if (this.dataset.repeat === 'true' && entry.intersectionRatio === 0) {
              this.classList.remove('vst-signup--revealed');
            }
          });
        }, { threshold: [0, 0.12] });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this._connected = false;
        cancelAnimationFrame(this.revealFrame);
        this.revealFrame = null;
        this.observer?.disconnect();
        this.motionPreference?.removeEventListener('change', this.handleMotionChange);
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vusi-media-features"] && !Shopify.designMode) return;
  try {
    
(() => {
 const controllers = new Map();
 function init(root) {
  root.querySelectorAll('.vusi-mf').forEach(section => {
   if (controllers.has(section)) return;
   const rail = section.querySelector('.vusi-mf__cards');
   const motion = matchMedia('(prefers-reduced-motion:reduce)');
   const videos = [...section.querySelectorAll('video[data-mf-auto]')];
   const warmed = new Set();
   const pending = new Set();
   const wanted = new Set();
   let nearby = false, approaching = false, frame = 0, disposed = false;
   function play(video) {
    if (disposed || !wanted.has(video) || !video.paused || pending.has(video)) return;
    pending.add(video);
    video.play().catch(() => {}).finally(() => {
     pending.delete(video);
     if (!wanted.has(video)) video.pause();
    });
   }
   function update() {
    frame = 0;
    const bounds = rail.getBoundingClientRect();
    videos.forEach(video => {
     const card = video.closest('.vusi-mf__card').getBoundingClientRect();
     const adjacent = card.right > bounds.left - card.width - 32 &&
       card.left < bounds.right + card.width + 32;
     if (nearby && adjacent && !warmed.has(video)) {
      warmed.add(video);
      video.preload = 'auto';
      if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) video.load();
     }
     const autoplay = video.dataset.mfAuto === 'true';
     if (approaching && card.right > bounds.left && card.left < bounds.right && autoplay && !motion.matches && !document.hidden) {
      wanted.add(video);
      play(video);
     } else {
      wanted.delete(video);
      if (autoplay && !video.paused) video.pause();
     }
    });
   }
   function schedule() {
    if (!frame && !disposed) frame = requestAnimationFrame(update);
   }
   const preloadObserver = new IntersectionObserver(entries => {
    nearby = entries[0].isIntersecting;
    schedule();
   }, {rootMargin:'600px 0px'});
   const playbackObserver = new IntersectionObserver(entries => {
    approaching = entries[0].isIntersecting;
    schedule();
   }, {rootMargin:'0px 0px', threshold:0});
   const ready = event => play(event.currentTarget);
   videos.forEach(video => {
    video.muted = true;
    video.playsInline = true;
    video.playbackRate = 1;
    video.addEventListener('loadeddata', ready);
    video.addEventListener('canplay', ready);
   });
   preloadObserver.observe(rail);
   playbackObserver.observe(rail);
   rail.addEventListener('scroll', schedule, {passive:true});
   rail.addEventListener('pointerdown', update, {passive:true});
   rail.addEventListener('touchstart', update, {passive:true});
   window.addEventListener('resize', schedule, {passive:true});
   motion.addEventListener('change', update);
   document.addEventListener('visibilitychange', update);
   controllers.set(section, () => {
    disposed = true;
    cancelAnimationFrame(frame);
    wanted.clear();
    preloadObserver.disconnect();
    playbackObserver.disconnect();
    rail.removeEventListener('scroll', schedule);
    rail.removeEventListener('pointerdown', update);
    rail.removeEventListener('touchstart', update);
    window.removeEventListener('resize', schedule);
    motion.removeEventListener('change', update);
    document.removeEventListener('visibilitychange', update);
    videos.forEach(video => {
     video.removeEventListener('loadeddata', ready);
     video.removeEventListener('canplay', ready);
     video.pause();
    });
   });
  });
 }
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
 document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.vusi-mf').forEach(section => {
   controllers.get(section)?.();
   controllers.delete(section);
  });
 });
 document.addEventListener('shopify:block:select', event => {
  const card = event.target.closest('.vusi-mf__card');
  if (card) card.scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vusi-media"] && !Shopify.designMode) return;
  try {
    
(() => {
 const controllers = new Map();
 function init(root) {
  root.querySelectorAll('.vusi-mf').forEach(section => {
   if (controllers.has(section)) return;
   const motion = matchMedia('(prefers-reduced-motion:reduce)');
   const visible = new Set();
   const videos = section.querySelectorAll('video[data-mf-auto="true"]');
   const update = () => videos.forEach(v => { if (visible.has(v) && !motion.matches && !document.hidden) v.play().catch(() => {}); else v.pause(); });
   const observer = new IntersectionObserver(entries => { entries.forEach(e => { if(e.isIntersecting) visible.add(e.target); else visible.delete(e.target); }); update(); },{threshold:.25});
   videos.forEach(v => observer.observe(v));
   motion.addEventListener('change',update); document.addEventListener('visibilitychange',update);
   controllers.set(section,()=>{observer.disconnect();motion.removeEventListener('change',update);document.removeEventListener('visibilitychange',update);});
  });
 }
 init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('.vusi-mf').forEach(s=>{controllers.get(s)?.();controllers.delete(s);});});
 document.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.vusi-mf__card');if(card)card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vusi-product-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vusi-product-cards')) {
    const vusiPlayback = window.VusiLoop || { play: video => Promise.resolve(video.play()), pause: video => video.pause(), paused: video => video.paused };
  customElements.define('vusi-product-cards', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.frame = requestAnimationFrame(() => this.start());
    }
    start() {
      if (!this.isConnected) return;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.cards.forEach(card => {
        const title = card.querySelector('[data-title]');
        if (title && !title.dataset.prepared) {
          const fullText = title.textContent.trim();
          const words = fullText.split(/\s+/u);
          const accessible = document.createElement('span');
          accessible.className = 'vst-cards__sr';
          accessible.textContent = fullText;
          const visible = document.createElement('span');
          visible.className = 'vst-cards__words';
          visible.setAttribute('aria-hidden', 'true');
          words.forEach((word, index) => {
            const mask = document.createElement('span');
            mask.className = 'vst-cards__word';
            const inner = document.createElement('span');
            inner.className = 'vst-cards__word-inner';
            inner.textContent = word;
            inner.style.setProperty('--vst-word-progress', words.length > 1 ? index / (words.length - 1) : 0);
            mask.append(inner);
            visible.append(mask);
          });
          title.replaceChildren(accessible, visible);
          title.dataset.prepared = 'true';
        }
      });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.setupVideos();
      this.measure();
      this.resize = new ResizeObserver(() => this.measure());
      this.cards.forEach(card => this.resize.observe(card.querySelector('.vst-cards__pill')));
      this.mobile.addEventListener('change', () => this.measure(), { signal: this.abort.signal });
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.revealAll(); }, { signal: this.abort.signal });
      this.addEventListener('focusin', event => {
        const card = event.target.closest('[data-card]');
        if (card) this.reveal(card, true);
      }, { signal: this.abort.signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-card]');
        if (card) this.reveal(card, true);
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) this.revealAll();
      }, { signal: this.abort.signal });
      if (this.dataset.animate !== 'true' || this.motion.matches || !('IntersectionObserver' in window)) return;
      this.dataset.ready = 'true';
      if (this.cards.length) getComputedStyle(this.cards[0]).opacity;
      const configuredThreshold = Number(this.dataset.threshold);
      const threshold = Number.isFinite(configuredThreshold) ? Math.max(0, Math.min(.5, configuredThreshold)) : .15;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
            this.reveal(entry.target);
            if (this.dataset.replay !== 'true') this.observer.unobserve(entry.target);
          } else if (this.dataset.replay === 'true' && entry.intersectionRatio === 0) {
            delete entry.target.dataset.instant;
            entry.target.dataset.entered = 'false';
          }
        });
      }, { threshold: [...new Set([0, threshold])] });
      this.cards.forEach(card => this.observer.observe(card));
    }
    setupVideos() {
      if (this.dataset.syncVideos !== 'false') { this.setupSyncedVideos(); return; }
      this.videos = Array.from(this.querySelectorAll('[data-card-video]'));
      this.videoVisibility = new WeakMap();
      this.videoPending = new WeakSet();
      this.videos.forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        const rect = video.getBoundingClientRect();
        this.videoVisibility.set(video, rect.bottom > 0 && rect.top < window.innerHeight);
        ['loadeddata', 'canplay'].forEach(name => video.addEventListener(name, () => this.syncVideo(video), { signal: this.abort.signal }));
      });
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.videoVisibility.set(entry.target, entry.isIntersecting);
            this.syncVideo(entry.target);
          });
        }, { threshold: 0 });
        this.videos.forEach(video => this.videoObserver.observe(video));
      }
      const sync = () => this.videos.forEach(video => this.syncVideo(video));
      this.mobile.addEventListener('change', sync, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', sync, { signal: this.abort.signal });
      window.addEventListener('pageshow', sync, { signal: this.abort.signal });
      document.addEventListener('pointerdown', sync, { passive: true, signal: this.abort.signal });
      sync();
    }
    setupSyncedVideos() {
      this.videos = Array.from(this.querySelectorAll('[data-card-video]'));
      this.syncStarted = new WeakSet();
      this.syncWarming = new WeakSet();
      this.syncPrimed = new WeakSet();
      this.syncPending = new WeakSet();
      this.syncLoaded = new WeakSet();
      this.syncHeroDeadline = Date.now() + 2500;
      this.syncStarting = false;
      this.syncBuffer = Math.max(0, Number(this.dataset.videoBuffer) || 0);
      this.dataset.videoStarting = 'true';
      this.videos.forEach(video => {
        video.autoplay = false;
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.playbackRate = 1;
        video.preload = 'none';
        vusiPlayback.pause(video);
      });
      const tick = () => this.tickSyncedVideos();
      this.videos.forEach(video => {
        video.addEventListener('loadeddata', tick, { signal: this.abort.signal });
        video.addEventListener('canplay', tick, { signal: this.abort.signal });
      });
      this.videoObserver = new IntersectionObserver(tick, { threshold: 0 });
      this.videos.forEach(video => this.videoObserver.observe(video));
      document.addEventListener('pointerdown', tick, { passive: true, signal: this.abort.signal });
      document.addEventListener('visibilitychange', tick, { signal: this.abort.signal });
      window.addEventListener('pageshow', tick, { signal: this.abort.signal });
      this.mobile.addEventListener('change', tick, { signal: this.abort.signal });
      this.syncTimer = setInterval(tick, 200);
      tick();
    }
    playStartedVideo(video) {
      if (!vusiPlayback.paused(video) || this.syncPending.has(video)) return;
      this.syncPending.add(video);
      Promise.resolve(vusiPlayback.play(video)).then(() => {
        if (!this.isConnected || document.hidden || !video.getClientRects().length) vusiPlayback.pause(video);
      }).catch(() => {}).finally(() => this.syncPending.delete(video));
    }
    heroIsReady() {
      if (this.syncHeroReady) return true;
      if (this.mobile.matches && Date.now() >= this.syncHeroDeadline) { this.syncHeroReady = true; return true; }
      const hero = document.querySelector('[id^="VusiHero-"]');
      const videos = hero ? Array.from(hero.querySelectorAll('video')).filter(video => video.getClientRects().length) : [];
      const images = hero ? Array.from(hero.querySelectorAll('img')).filter(image => image.getClientRects().length) : [];
      this.syncHeroReady = videos.length ? videos.every(video => video.error || video.readyState >= 3) : images.every(image => image.complete);
      return this.syncHeroReady;
    }
    videoStartTime(video) {
      return Number.isFinite(video.duration) ? video.duration * (Number(video.dataset.startFraction) || 0) : 0;
    }
    videoHasStartBuffer(video) {
      if (video.error || video.seeking) return false;
      if (this.mobile.matches) return video.readyState >= 3;
      if (video.readyState < 3) return false;
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const start = this.videoStartTime(video);
      const target = this.syncBuffer;
      const needed = duration > 0 ? Math.min(start + target, Math.max(0, duration - .05)) : target;
      for (let index = 0; index < video.buffered.length; index++) {
        if (video.buffered.start(index) <= start + .05 && video.buffered.end(index) >= needed) return true;
      }
      return needed === 0;
    }
    waitForVideo(video, ready) {
      return new Promise((resolve, reject) => {
        const signal = this.abort.signal;
        const finish = error => {
          clearInterval(poll);
          clearTimeout(timeout);
          signal.removeEventListener('abort', cancelled);
          error ? reject(error) : resolve();
        };
        const cancelled = () => finish(new Error('Video preparation cancelled'));
        const check = () => {
          if (!this.isConnected || signal.aborted || video.error || document.hidden || !video.getClientRects().length) { cancelled(); return; }
          if (ready()) finish();
        };
        const poll = setInterval(check, 50);
        const timeout = setTimeout(cancelled, 15000);
        signal.addEventListener('abort', cancelled, { once: true });
        check();
      });
    }
    primeMobileVideo(video) {
      this.syncWarming.add(video);
      this.playVideoWithDeadline(video).catch(() => {});
      this.waitForVideo(video, () => this.videoHasStartBuffer(video)).then(() => {
        vusiPlayback.pause(video);
        const start = this.videoStartTime(video);
        if (video.currentTime !== start) video.currentTime = start;
        return this.waitForVideo(video, () => this.videoHasStartBuffer(video));
      }).then(() => this.syncPrimed.add(video)).catch(() => {
        vusiPlayback.pause(video);
      }).finally(() => this.syncWarming.delete(video));
    }
    playVideoWithDeadline(video) {
      let timeout;
      return Promise.race([
        Promise.resolve().then(() => vusiPlayback.play(video)),
        new Promise((resolve, reject) => { timeout = setTimeout(() => reject(new Error('Video start timed out')), 4000); })
      ]).finally(() => clearTimeout(timeout));
    }
    tickSyncedVideos() {
      if (!this.isConnected) return;
      if (this.mobile.matches) {
        this.dataset.videoStarting = 'false';
        this.videos.forEach(video => {
          const rect = video.getBoundingClientRect();
          const active = video.getClientRects().length > 0;
          if (active && !this.syncLoaded.has(video)) {
            this.syncLoaded.add(video);
            video.preload = 'auto';
          }
          if (active && !document.hidden && rect.bottom > 0 && rect.top < innerHeight) {
            video.defaultMuted = true;
            video.muted = true;
            video.volume = 0;
            video.loop = true;
            this.syncStarted.add(video);
            this.playStartedVideo(video);
          } else vusiPlayback.pause(video);
        });
        return;
      }

      const group = this.videos.filter(video => video.getClientRects().length > 0);
      const inView = group.some(video => { const rect = video.getBoundingClientRect(); return rect.bottom > 0 && rect.top < window.innerHeight; });
      this.videos.forEach(video => {
        if ((document.hidden || (!inView && !this.syncWarming.has(video)) || !group.includes(video)) && !vusiPlayback.paused(video)) vusiPlayback.pause(video);
      });
      if (document.hidden) return;
      if (this.syncStarting) return;
      if (this.mobile.matches && inView) this.syncHeroReady = true;
      if (!this.heroIsReady()) return;
      group.forEach(video => {
        if (this.syncLoaded.has(video)) return;
        this.syncLoaded.add(video);
        video.preload = 'auto';
        video.load();
      });
      if (inView) group.filter(video => this.syncStarted.has(video)).forEach(video => this.playStartedVideo(video));
      const waiting = group.filter(video => !this.syncStarted.has(video));
      if (!waiting.length) return;
      if (this.mobile.matches) {
        let warming = false;
        waiting.forEach(video => {
          if (this.syncWarming.has(video)) { warming = true; return; }
          if (this.syncPrimed.has(video) || video.error) return;
          warming = true;
          this.primeMobileVideo(video);
        });
        if (warming) return;
      } else {
        waiting.forEach(video => {
          if (this.syncPrimed.has(video) || video.readyState < 1) return;
          vusiPlayback.pause(video);
          const start = this.videoStartTime(video);
          if (video.currentTime !== start) video.currentTime = start;
          this.syncPrimed.add(video);
        });
      }
      if (!inView) return;
      const ready = waiting.every(video => this.videoHasStartBuffer(video));
      if (!ready) return;
      if (this.syncReleaseFrame) return;
      this.syncReleaseFrame = requestAnimationFrame(() => {
        this.syncReleaseFrame = null;
        if (!this.isConnected || document.hidden || waiting.some(video => !video.getClientRects().length)) return;
        if (!waiting.every(video => this.videoHasStartBuffer(video))) return;
        if (!this.mobile.matches) {
          waiting.forEach(video => this.syncStarted.add(video));
          waiting.forEach(video => this.playStartedVideo(video));
          this.dataset.videoStarting = 'false';
          return;
        }
        this.syncStarting = true;
        Promise.allSettled(waiting.map(video => this.playVideoWithDeadline(video))).then(results => {
          if (!this.isConnected || document.hidden || results.some(result => result.status === 'rejected')) {
            waiting.forEach(video => { vusiPlayback.pause(video); this.syncPrimed.delete(video); });
            this.syncStarting = false;
            return;
          }
          this.syncReleaseFrame = requestAnimationFrame(() => {
            this.syncReleaseFrame = null;
            if (!this.isConnected || document.hidden) {
              waiting.forEach(video => { vusiPlayback.pause(video); this.syncPrimed.delete(video); });
              this.syncStarting = false;
              return;
            }
            waiting.forEach(video => this.syncStarted.add(video));
            this.dataset.videoStarting = 'false';
            this.syncStarting = false;
          });
        });
      });
    }

    syncVideo(video) {
      const active = !document.hidden && this.videoVisibility.get(video) !== false && video.getClientRects().length > 0;
      if (!active) { vusiPlayback.pause(video); return; }
      if (!vusiPlayback.paused(video) || this.videoPending.has(video)) return;
      video.muted = true;
      this.videoPending.add(video);
      const playback = vusiPlayback.play(video);
      if (playback && typeof playback.then === 'function') {
        playback.then(() => {
          if (!this.isConnected || document.hidden || this.videoVisibility.get(video) === false || !video.getClientRects().length) vusiPlayback.pause(video);
        }).catch(() => {}).finally(() => this.videoPending.delete(video));
      } else this.videoPending.delete(video);
    }
    measure() {
      this.cards.forEach((card, index) => {
        card.style.setProperty('--vst-card-delay', `${this.mobile.matches ? 0 : index % 2 * (Number(this.dataset.stagger) || 0)}ms`);
        const pill = card.querySelector('.vst-cards__pill');
        card.style.setProperty('--vst-pill-height', `${pill.getBoundingClientRect().height}px`);
      });
    }
    reveal(card, instant = false) {
      if (instant) card.dataset.instant = 'true';
      card.dataset.entered = 'true';
    }
    revealAll() {
      this.cards.forEach(card => this.reveal(card, true));
      this.observer?.disconnect();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      clearInterval(this.syncTimer);
      cancelAnimationFrame(this.syncReleaseFrame);
      this.videoObserver?.disconnect();
      this.videos?.forEach(video => vusiPlayback.pause(video));
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
